<template>
  <div class="pb-5">
    <nav-bar/>
    <!-- <sidebar-toggle-button/> -->

    <!-- Sidebar -->
    <!-- <div class="sidebar bg-darkgrey navbar-inverse side-box-shadow" v-if="$store.state.isSidebarOpen">
      <ul class="nav flex-column">
        <li class="nav-item" id="current">
          <a class="nav-link navbar-text pull-left" href="#/Zone">
            {{$t('OrderCurrent.sidebar.current')}}
          </a>
          </li>
        <li class="nav-item" :class="{'current': view.query.name === $route.query.name}" v-for="(view, index) in customViews" :key="index">
          <router-link :to="{name: 'Zone', query: view.query}" class="nav-link navbar-text pull-left">
            {{view.query.name}}
          </router-link>
        </li>
        <li class="nav-item" v-if="isAdmin">
          <a class="nav-link navbar-text pull-left" href="" @click.prevent="modal.newCustomView = true">
            {{$t('OrderCurrent.sidebar.add_custom_view')}}
          </a> 
          <button class="btn btn-sm btn-kne-orange" @click.prevent="modal.newCustomView = true">
            <i class="fa fa-plus fa-lg" aria-hidden="true" />
          </button>
          <button class="btn btn-sm btn-kne-orange" @click.prevent="modal.deleteCustomView = true">
            <i class="fa fa-minus fa-lg" aria-hidden="true" />
          </button>
        </li>
      </ul>
    </div> -->

    <!-- misc-content section -->
    <!-- Map container -->
    <h4 v-if="wallFileName" class="mt-2 mx-2 bg-darkgrey color-white p-3 text-center">{{ 'Wallfile: ' + wallFileName }}</h4>

    <div class="text--center" :class="{'mobile-maps-container' : isScreenSmall, 'maps-container px-2' : !isScreenSmall}">

      <!-- Current Location map -->
      <div class="mt-2 maps-subcontainer" :class="{'mobile-map' : isScreenSmall, 'border': isPickupOpen}">
        <div class="kne-subtitle cursor-pointer map-title" @click="toggleMap('pick')">
          <h4 class="my-2">{{$t('Zone.currentLocation') + "  "}}</h4>
          <p class="toggle-arrow ml-2">{{ isPickupOpen ? '▼' : '▶' }}</p>
        </div>
        <transition name="map-toggle">
          <div v-if="isPickupOpen">
            <gmap-map
              ref="map"
              :center="center"
              :zoom="8"
              style="width:100%; height: 450px;">
              <GmapCluster
                :position="center"
                :clickable="true"
                :animation="2"
                :minimumClusterSize="5"
                :gridSize="25"
                :zoomOnClick="true"
                :enableRetinaIcons="true"
                :maxZoom="zoom">
    
                <gmap-marker
                  v-for="(item, index) in markers"
                  :key="index"
                  :position="item.posCurrent3"
                  :clickable="true"
                  :icon="item.fullOrder.icon"
                  @click="toggleInfoWindow(item, index)">
                </gmap-marker>
    
                <gmap-marker
                  v-if="driverStatus"
                  :key="index"
                  :position="driverLocation"
                  :clickable="true"
                  :icon="{
                    path: 'M464.5 53.5q184.5 0 315.5 131t131 315.5 -131 315.5 -315.5 131 -315.5 -131 -131 -315.5 131 -315.5 315.5 -131zm0 112q-106.5 0 -192.5 62t-122 161l629 0q-36 -99 -122 -161t-192.5 -62zm-.5 390q24 0 40.5 -16.5t16.5 -39.5q0 -24 -17 -40t-39.5 -16 -39 16 -16.5 40 16.5 40 38.5 16zm-334 -56q0 124 79 216.5t199 112.5q-2 -137 -83 -233t-195 -96zm391 329q120 -20 199 -112.5t79 -216.5q-114 0 -195 96t-83 233z',
                    fillColor: 'green',
                    fillOpacity: 1,
                    strokeWeight: 0.2,
                    scale: 0.025
                  }" />
    
                <gmap-info-window
                  :options="infoOptions"
                  :position="infoWindowPos3"
                  :opened="infoWinOpen"
                  @closeclick="infoWinOpen=false">
                  <div v-html="infoContent"></div>
                </gmap-info-window>
              </GmapCluster>
            </gmap-map>
    
            <div v-if="isLegend" class="legend">
              <span>
                <img :src="this.greenCar">
                <hover-tool-tip
                  top
                  right
                  :text="`${$t('Zone.order_created_less')} ${greenOrderDayLimit} ${$t('Zone.order_created_2')}`"
                  :iconText="greenCarCount"
                  :iconColor="'white'"
                  :iconBackgroundColor="'#239700'"
                  strong
                />
              </span>
              <span>
                <img :src="this.orangeCar">
                <hover-tool-tip
                  top
                  left
                  :text="`${$t('Zone.order_created_less')} ${orangeOrderDayLimit} ${$t('Zone.order_created_2')}`"
                  :iconText="orangeCarCount"
                  :iconColor="'white'"
                  :iconBackgroundColor="'#e37d00'"
                  strong
                />
              </span>
              <span>
                <img :src="this.redCar">
                <hover-tool-tip
                  top
                  left
                  :text="`${$t('Zone.order_created_more')} ${orangeOrderDayLimit}+ ${$t('Zone.order_created_2')}`"
                  :iconText="redCarCount"
                  :iconColor="'white'"
                  :iconBackgroundColor="'#ca251c'"
                  strong
                />
              </span>
            </div>
          </div>
        </transition>
      </div>

      <!-- Destination map -->
      <div class="mt-2 maps-subcontainer" :class="{'mobile-map' : isScreenSmall, 'border': isDestinationOpen}">
        <div class="kne-subtitle cursor-pointer flex map-title" @click="toggleMap('dest')" >
          <h4 class="my-2">{{$t('Zone.destination')}}</h4>
          <p class="toggle-arrow ml-2">{{ isDestinationOpen ? '▼' : '▶' }}</p>
        </div>
        <transition name="map-toggle">
          <div v-if="isDestinationOpen">
            <gmap-map
              ref="destinationMap"
              :center="center"
              :zoom="8"
              style="width:100%; height: 450px;">
              <GmapCluster
                :position="center"
                :clickable="true"
                :animation="2"
                :minimumClusterSize="5"
                :gridSize="25"
                :zoomOnClick="true"
                :enableRetinaIcons="true"
                :maxZoom="zoom">
    
                <gmap-marker
                  v-for="(item, index) in markers"
                  :key="index"
                  :position="item.posDestination2"
                  :clickable="true"
                  :icon="item.fullOrder.icon"
                  @click="toggleInfoWindow(item, index)">
                </gmap-marker>
    
                <gmap-info-window
                  :options="infoOptions"
                  :position="infoWindowPos2"
                  :opened="infoWinOpen"
                  @closeclick="infoWinOpen=false">
                  <div v-html="infoContent"></div>
                </gmap-info-window>
              </GmapCluster>
            </gmap-map>
    
            <div v-if="isLegend" class="legend">
              <span>
                <img :src="this.greenCar">
                <hover-tool-tip
                  top
                  right
                  :text="`${$t('Zone.order_created_less')} ${greenOrderDayLimit} ${$t('Zone.order_created_2')}`"
                  :iconText="greenCarCount"
                  :iconColor="'white'"
                  :iconBackgroundColor="'#239700'"
                  strong
                />
              </span>
              <span>
                <img :src="this.orangeCar">
                <hover-tool-tip
                  top
                  left
                  :text="`${$t('Zone.order_created_less')} ${orangeOrderDayLimit} ${$t('Zone.order_created_2')}`"
                  :iconText="orangeCarCount"
                  :iconColor="'white'"
                  :iconBackgroundColor="'#e37d00'"
                  strong
                />
              </span>
              <span>
                <img :src="this.redCar">
                <hover-tool-tip
                  top
                  left
                  :text="`${$t('Zone.order_created_more')} ${orangeOrderDayLimit}+ ${$t('Zone.order_created_2')}`"
                  :iconText="redCarCount"
                  :iconColor="'white'"
                  :iconBackgroundColor="'#ca251c'"
                  strong
                />
              </span>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div class="content-container mt-2 p-2" :class="{'content-container-mobile' : isScreenSmall}">
      <div class="misc-content-container" :class="{'misc-content-container-mobile' : isScreenSmall}">

        
        <!-- misc-content actions -->
        <div class="misc-content">
          <!-- Order status Counter -->
          <order-status-counter
            :filterResults="filterResults"
            :processedArray="processing"
            :isWallfileZonePage="checkWallFileZonePage"
            @updatedNewCount="computed_newCount">
          </order-status-counter>

          <table-element
            :sortable="true"
            :isShowFilter="true"
            :title="$t('OrderCurrent.title')"
            :fields="fieldsObj"
            :arrOfElement="processing"
            :sortSpacing="3"
            :driversSort="disableDefaultSort || enableDriversSort"
            :isShowSelectAll="true"
            class="card my-3"
            @updateFilterResults="updateFilterResults"
            @updateSelectedOrders="updateSelectedOrders"
          >

            <template #header-actions>
              <p><i class="text-center">{{$t('Zone.title_tooltip')}}</i></p>
              <button :disabled="selected.length < 1" @click="setOrderInfo()" class="btn btn-kne-orange m-1">{{$t('Zone.optimizeRoute')}}</button>
              <button :disabled="selected.length < 1" @click="openShortDispatch()" class="btn btn-kne-orange m-1" >{{$t('OrderCurrent.actions.shortDispatch')}}</button>
              <button :disabled="selected.length < 1" @click="openStatusEdit();" class="m-1 btn btn-kne-orange">{{$t('OrderCurrent.actions.quick_status')}}</button>
              <button :disabled="selected.length < 1" @click="openVinPrinting(); clearfeedbackMessage()" class="m-1 btn btn-kne-orange">{{$t('OrderCurrent.actions.printVin')}}</button>
              <button v-if="driversFile"  @click="openDeliveryOrder()" class="btn btn-kne-orange m-1" >Change Order</button>
              <button v-if="lateOrdersPresent" :disabled="selected.length < 1" @click="openLateTimeExtentionModal();" class="m-1 btn btn-kne-orange">{{$t('OrderCurrent.actions.late_time_extension')}}</button>
              <button @click="addMarkerWithArray()" class="btn btn-kne-orange m-1">{{$t('Zone.refresh')}}</button>
              <button @click="showFilterZonesModal = true; clearCurrentPolygon('filterZonesModal'); clearDestinationPolygon('filterZonesModal')" class="btn btn-kne-orange m-1">{{ $t('Zone.filter_zones') }}</button>
              <filter-zones-modal v-if="showFilterZonesModal" 
               :pickZones="pickZones" :dropZones="dropZones" 
               :filteredPickZones="filteredPickZones" :filteredDropZones="filteredDropZones"
               @closeModal="showFilterZonesModal = false" @filterZones="filterZones" />
            </template>

            <template #body-content-desktop="content">
              <!-- List of orders -->
              <tr v-for="(order, index) in content.results"
              class="table-element_hover text-center"
              :key="order['.key']"
              :class="{
                'red': order.isLate,
                'orange': order.isPartialLate,
                'yellow': order.isWarning,
                'drop': order.status === 'Drop',
                'cancel': order.status === 'Cancel',
                'waiting': order.status === 'Attente',
                'pick': order.status === 'Pick',
                'transit': order.status === 'Transit',
                'dispatch': order.status === 'Dispatch',
                'reject': order.status === 'Reject',
                'inspection': order.status === 'Inspection',
                'transfered': order.status === 'Transférée'
              }">
                <!-- <td class="pt-2">
                  <router-link :to="{name: 'OrderInfo', query: {orderId: order['.key']}}">
                    <input type="button" class="btn btn-kne-orange" :value="$t('OrderCurrent.view')">
                  </router-link>
                </td> -->
                <td class="pt-2">
                  <regular-checkbox
                      :checked="selected.includes(order['.key'])"
                      @change="handleCheckboxChange($event, order['.key'])"
                      class="ml-2 mr-0" />
                </td>
                <td class="pt-2">
                  <router-link :to="{name: 'OrderInfo', query: {orderId: order['.key']}}">
                    <input type="button" class="btn btn-kne-orange" :value="$t('OrderCurrent.view')">
                  </router-link>
                </td>
                <td v-if="!isDateRoute" class="pt-2">
                  <a :href="order.invoice" target="_blank" @click="print(order)" :disabled="disableActions(order)">
                    <!-- <input type="button" class="btn btn-kne-orange pull-right" :value="$t('OrderCurrent.view')"> -->
                    <button class="btn btn-kne-orange" :class="{'printed': order.isPrinted}" :disabled="disableActions(order)">
                    <!-- <button class="btn btn-kne-orange pull-right" :class="{'printed': !order.isPrinted}"> -->
                      <i class="fa fa-print" aria-hidden="true" />
                    </button>
                  </a>
                </td>
                <!-- <td class="pt-2">
                  <button class="btn btn-kne-orange" @click="generateDocuments(order)">
                      <i class="fas fa-sync" aria-hidden="true" />
                  </button>
                </td> -->
                <!-- <td v-if="!isDateRoute" class="pt-3">
                  <a :href="order.invoice" target="_blank" @click="print(order)">
                  </a>
                </td>
                <td v-if="order.docs" class="pt-3">
                    <i class="fa fa-file" aria-hidden="true" />
                </td>
                <td v-if="!order.docs" class="pt-2">
                </td> -->
                <td v-if="isDateRoute" class="pt-2">
                    <input v-if="checkDate(order.datePromis)" type="button" class="btn btn-kne-red" :value="calcBusinessDays(order.datePromis)">
                    <input v-if="!checkDate(order.datePromis)" type="button" class="btn btn-kne-green" :value="calcBusinessDays2(order.datePromis)">
                </td>
                <td class="pt-3">
                  <hover-tool-tip
                    v-if="order.survey"
                    :text="getOrderSurvey(order.survey)"
                    :iconColor="getSurveyIconColor(order.survey)"
                    bottom
                    right
                    :clickable="false"
                    :displayFixed="true"
                  />
                </td>
                <td class="nowrap pt-3">{{order['.key']}}
                  <hover-tool-tip
                    :text="`<div>
                              ${order.source || '-'}
                              <br>${getDate(order.creationDate) || '-'}
                              <br>${order.make || '-'} ${order.model || '-'} ${order.year || '-'}
                            </div>`"
                    :top="true"
                    :right="true"
                    clickable
                  />
                  <hover-tool-tip
                    v-if="order.historySync"
                    :text="dispatchHistToolTip(order)"
                    :iconText="getOrderHistoryLength(order)"
                    :iconColor="'black'"
                    :iconBackgroundColor="'white'"
                    :top="true"
                    :right="true"
                    :clickable="false"
                  />
                </td>
                <td class="nowrap pt-3">{{ formatDate(order.creationDate) }}</td>
                <td class="nowrap pt-3">{{ order.model }}</td>
                <td class="nowrap pt-3">{{ order.vin }}</td>
                <td class="nowrap pt-3">
                  <span class="table-fix-width">{{shortenString($realName(order, 'transmitter'))}}
                    <hover-tool-tip
                      :text="`${order.transmitterAddress} ${order.transmitterCity}, ${order.transmitterProvince} ${order.transmitterPostcode}, ${order.transmitterCountry}`"
                      :right="true"
                      :top="true"
                      :clickable="true"
                    />
                  </span>
                  <div v-if="order.transmitterZone" class="fw-700">({{order.transmitterZone}})</div>
                </td>
                <td class="nowrap pt-3">
                  <span class="table-fix-width">{{shortenString($realName(order, 'receiver'))}}
                    <hover-tool-tip
                      :text="`${order.receiverAddress} ${order.receiverCity}, ${order.receiverProvince} ${order.receiverPostcode}, ${order.receiverCountry}`"
                      :left="true"
                      :top="true"
                      :clickable="true"
                    />
                  </span>
                  <div v-if="order.receiverZone" class="fw-700">({{order.receiverZone}}) </div>
                </td>
                <td class="nowrap pt-3"><p class="table-fix-width">{{shortenString($realName(order, 'payer'))}}</p></td>
                <td class="nowrap pt-3">
                  <span v-if="order.isMarketplaceOffer">{{$t('Search.status.marketplace')}}</span>
                  <span v-else-if="order.status === 'Dispatch'">{{$t('Search.status.dispatch')}}</span>
                  <span v-else-if="order.status === 'Processing'">{{$t('Search.status.processing')}}</span>
                  <span v-else-if="order.status === 'Pick'">{{$t('Search.status.pick')}}</span>
                  <span v-else-if="order.status === 'Attente'">{{$t('Search.status.waiting')}}</span>
                  <span v-else-if="order.status === 'Transit'">{{$t('Search.status.transit')}}</span>
                  <span v-else-if="order.status === 'Drop'">{{$t('Search.status.drop')}}</span>
                  <span v-else-if="order.status === 'Cancel'">{{$t('Search.status.canceled')}}</span>
                  <span v-else-if="order.status === 'Terminée'">{{$t('Search.status.finished')}}</span>
                  <span v-else-if="order.status === 'Transférée'">{{$t('Search.status.transfered')}}</span>
                  <span v-else-if="order.status === 'Reject'">{{$t('Search.status.rejected')}}</span>
                  <span v-else-if="order.status === 'Inspection'">{{$t('Search.status.inspection')}}</span>
                  <hover-tool-tip
                    v-if="order.notes"
                    :text="getOrderNotes(order)"
                    :left="true"
                    :top="true"
                    :clickable="false"
                  />
                </td>
                <td class="nowrap pt-3"><p class="table-fix-width">{{order.driverName || '-'}}</p></td>
                <td v-if="driversFile" class="nowrap pt-3"><p class="table-fix-width">{{order.deliveryOrder || '-'}}</p></td>
              </tr>
            </template>

            <template #body-content-mobile="content">
              <div class="card my-3 mx-2" v-for="(order) in content.results"
              :key="order['.key']" :class="{'drop': order.status === 'Drop', 'cancel': order.status === 'Cancel', 'waiting': order.status === 'Attente', 'pick': order.status === 'Pick', 'transit': order.status === 'Transit', 'dispatch': order.status === 'Dispatch', 'reject': order.status === 'Reject', 'inspection': order.status === 'Inspection'}">
                <div style="display: flex;">
                  <label class="custom-control custom-checkbox form-control-lg mt-1 ml-2" id="checkBox">
                    <input :value="order['.key']" v-model="selected" type="checkbox" class="custom-control-input">
                    <span class="custom-control-indicator form-control-lg"></span>
                  </label>
                  <div v-if="order.docs" id="fileIcon">
                      <i class="fa fa-file" aria-hidden="true" />
                  </div>
                </div>

                <div class="card-header m-2">
                  <h4>{{order['.key'] || '-'}}</h4>
                  <p v-if="isDateRoute"><i class="fa fa-calendar" /> {{ order.datePromis || '-'}}</p>
                  <p><i class="fa fa-calendar" /> {{ getDate(order.creationDate) || '-'}}</p>
                  <p v-if="order.status === 'Dispatch'"><i class="fa fa-exclamation" /> {{$t('Search.status.dispatch')}}</p>
                  <p v-if="order.status === 'Processing'"><i class="fa fa-exclamation" /> {{$t('Search.status.processing')}}</p>
                  <p v-if="order.status === 'Pick'"><i class="fa fa-exclamation" /> {{$t('Search.status.pick')}}</p>
                  <p v-if="order.status === 'Waiting'"><i class="fa fa-exclamation" /> {{$t('Search.status.waiting')}}</p>
                  <p v-if="order.status === 'Transit'"><i class="fa fa-exclamation" /> {{$t('Search.status.transit')}}</p>
                  <p v-if="order.status === 'Drop'"><i class="fa fa-exclamation" /> {{$t('Search.status.drop')}}</p>
                  <p v-if="order.status === 'Cancel'"><i class="fa fa-exclamation" /> {{$t('Search.status.canceled')}}</p>
                  <p v-if="order.status === 'Terminée'"><i class="fa fa-exclamation" /> {{$t('Search.status.finished')}}</p>
                  <p v-if="order.status === 'Transférée'"><i class="fa fa-exclamation" /> {{$t('Search.status.transfered')}}</p>
                  <p v-if="order.status === 'Reject'"><i class="fa fa-exclamation" /> {{$t('Search.status.rejected')}}</p>
                  <p v-if="order.status === 'Inspection'"><i class="fa fa-exclamation" /> {{$t('Search.status.inspection')}}</p>
                </div>

                <p v-if="!order.docs"> </p>
                <div class="m-2" v-if="isDateRoute">
                  <input v-if="checkDate(order.datePromis)" type="button" class="btn btn-kne-red" :value="calcBusinessDays(order.datePromis)">
                  <input v-if="!checkDate(order.datePromis)" type="button" class="btn btn-kne-green" :value="calcBusinessDays2(order.datePromis)">
                </div>

                <div class="m-2">
                  <p>
                    <span><i class="fas fa-tools" /> {{order.make || '-'}}</span>
                    <span>| <i class="fa fa-car" /> {{order.model || '-'}}</span>
                    <span>| <i class="fas fa-calendar-alt" /> {{order.year || '-'}}</span>
                  </p>
                  <p><i class="fa fa-user" /> {{order.driverName || '-'}}</p>
                  <p><i class="fa fa-home" /> {{$realName(order, 'transmitter') || '-'}}</p>
                  <p><i class="fa fa-truck" /> {{$realName(order, 'receiver') || '-'}}</p>
                  <p><i class="fa fa-credit-card" /> {{$realName(order, 'payer') || '-'}}</p>
                </div>
                <div id="action">
                  <router-link :to="{name: 'OrderInfo', query: {orderId: order['.key']}}">
                    <input type="button" class="btn btn-kne-orange m-2" :value="$t('OrderCurrent.view')">
                  </router-link>
                  <div v-if="!isDateRoute">
                    <a :href="order.invoice" target="_blank" @click="print(order)">
                      <button class="btn btn-kne-orange m-2" :class="{'printed': order.isPrinted}">
                        <i class="fa fa-print" aria-hidden="true" />
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </template>
          </table-element>

          <loading-render v-if="isLoading"/>
        </div>
      </div>
    </div>

    <!-- All modals -->
    <transition name="fade">

      <!-- Distributed History -->
      <distributed-history-modal
        v-if="isDistributedModal"
        key="distributed"
        ref="distModal"
        @closeModal="isDistributedModal = false"
        @updateOrderInSelectedFull="(orderId, historyKey, order) => updateOrderInSelectedFull(orderId, historyKey, order)"
      />

      <!-- Delivery Location -->
      <delivery-location-modal
        v-if="isDeliveryLocationModal"
        ref="delivLocModal"
        :addressbook="addressbook"
        :originalOrder="selectedOrder"
        :showBilling="false"
        @closeModal="isDeliveryLocationModal = false"
        @emitNewOrderLocation="updateOrderLocation"
      />

      <!-- Short Dispatch Modal -->
      <short-dispatch-modal
        v-if="isShortDispatchModal"
        ref="shortDispatchModal"
        :arrOfOrder="selectedFull"
        :liste="liste"
        :addressbook="addressbook"
        :priceOrderLink="priceOrderLink"
        :isOrderNbClickable="true"
        @closeModal="isShortDispatchModal = false; clear()"
        @clearSelected="clearSelected"
      />

      <late-time-extension-modal
        v-if="lateTimeExtension"
        ref="shortDispatchModal"
        :arrOfOrder="selectedFull"
        :isOpen="lateTimeExtension"
        :priceOrderLink="priceOrderLink"
        @closeModal="lateTimeExtension = false; clear()"
        @clearSelected="clearSelected"
      />

      <status-change-modal
        v-if="isStatusEdit"
        ref="shortDispatchModal"
        :arrOfOrder="selectedFull"
        :isOpen="isStatusEdit"
        :priceOrderLink="priceOrderLink"
        @closeModal="isStatusEdit = false; clear()"
        @clearSelected="clearSelected"
      />

      <delivery-order-modal
        v-if="isDeliveryOrderModal"
        :driverName="driverName"
        :arrOfOrder="driversDispatchOrders"
        :isOrderNbClickable="true"
        @clearSelected="clearSelected"
        @closeModal="isDeliveryOrderModal = false; clear()"
      />

      <!-- New view creation -->
      <modal
        :title="$t('OrderCurrent.sidebar.add_custom_view')"
        v-if="modal.newCustomView"
        @close-request="modal.newCustomView = false; clear()"
        closable
      >
        <div class="container-fluid">
          <div class="row">
            <regular-input
              :value="newCustomView.name"
              @input="newCustomView.name = $event"
              type="text" :placeholder="$t('OrderCurrent.modal.name')" class="col-12 form-group"/>
            <regular-input
              :value="newCustomView.VIN"
              @input="newCustomView.VIN = $event"
              type="text" :placeholder="$t('Search.VIN')" class="col-12 col-sm-6 form-group"/>
            <regular-input
              :value="newCustomView.referenceNumber"
              @input="newCustomView.referenceNumber = $event"
              type="text" :placeholder="$t('Search.reference')" class="col-12 col-sm-6 form-group"/>
            <regular-input
              :value="newCustomView.source"
              @input="newCustomView.source = $event"
              type="text" :placeholder="$t('Search.source')" class="col-12 col-sm-6 form-group"/>
            <regular-input
              :value="newCustomView.pickup"
              @input="newCustomView.pickup = $event"
              type="text" :placeholder="$t('Search.pickup')" class="col-12 col-sm-6 form-group"/>
            <regular-input
              :value="newCustomView.delivery"
              @input="newCustomView.delivery = $event"
              type="text" :placeholder="$t('Search.delivery')" class="col-12 col-sm-6 form-group"/>
            <regular-input
              :value="newCustomView.billing"
              @input="newCustomView.billing = $event"
              type="text" :placeholder="$t('Search.billing')" class="col-12 col-sm-6 form-group"/>
            <regular-select
              :value="newCustomView.status"
              @change="newCustomView.status = $event"
              :placeholder="$t('OrderCurrent.searchSelection')" class="col-12 col-sm-6 form-group">
              <option value="Processing">{{$t('Search.status.processing')}}</option>
              <option value="Dispatch">{{$t('Search.status.dispatch')}}</option>
              <option value="Pick">{{$t('Search.status.pick')}}</option>
              <option value="Transit">{{$t('Search.status.transit')}}</option>
              <option value="Drop">{{$t('Search.status.drop')}}</option>
              <option value="Cancel">{{$t('Search.status.canceled')}}</option>
              <option value="Terminée">{{$t('Search.status.finished')}}</option>
              <option value="Transférée">{{$t('Search.status.transfered')}}</option>
              <option value="Reject">{{$t('Search.status.rejected')}}</option>
              <option value="Attente">{{$t('Search.status.waiting')}}</option>
            </regular-select>
            <regular-datalist-driver
              :value="newCustomView.driver"
              @input="newCustomView.driver = $event.value"
              :secondList="liste"
              :placeholder="$t('Search.driver')" class="col-12 col-sm-6 form-group"/>
            <regular-select
              :value="newCustomView.provincePick"
              @change="newCustomView.provincePick = $event"
              :placeholder="$t('OrderCurrent.modal.provinceOrigin')" class="col-12 col-sm-6 form-group">
              <option value="AB">{{$t('OrderCurrent.province.AB')}}</option>
              <option value="BC">{{$t('OrderCurrent.province.BC')}}</option>
              <option value="MB">{{$t('OrderCurrent.province.MB')}}</option>
              <option value="NB">{{$t('OrderCurrent.province.NB')}}</option>
              <option value="NL">{{$t('OrderCurrent.province.NL')}}</option>
              <option value="NS">{{$t('OrderCurrent.province.NS')}}</option>
              <option value="NT">{{$t('OrderCurrent.province.NT')}}</option>
              <option value="NU">{{$t('OrderCurrent.province.NU')}}</option>
              <option value="ON">{{$t('OrderCurrent.province.ON')}}</option>
              <option value="PE">{{$t('OrderCurrent.province.PE')}}</option>
              <option value="QC">{{$t('OrderCurrent.province.QC')}}</option>
              <option value="SK">{{$t('OrderCurrent.province.SK')}}</option>
              <option value="YT">{{$t('OrderCurrent.province.YT')}}</option>
            </regular-select>
            <regular-select
              :value="newCustomView.provinceDrop"
              @change="newCustomView.provinceDrop = $event"
              :placeholder="$t('OrderCurrent.modal.provinceArrival')" class="col-12 col-sm-6 form-group">
              <option value="AB">{{$t('OrderCurrent.province.AB')}}</option>
              <option value="BC">{{$t('OrderCurrent.province.BC')}}</option>
              <option value="MB">{{$t('OrderCurrent.province.MB')}}</option>
              <option value="NB">{{$t('OrderCurrent.province.NB')}}</option>
              <option value="NL">{{$t('OrderCurrent.province.NL')}}</option>
              <option value="NS">{{$t('OrderCurrent.province.NS')}}</option>
              <option value="NT">{{$t('OrderCurrent.province.NT')}}</option>
              <option value="NU">{{$t('OrderCurrent.province.NU')}}</option>
              <option value="ON">{{$t('OrderCurrent.province.ON')}}</option>
              <option value="PE">{{$t('OrderCurrent.province.PE')}}</option>
              <option value="QC">{{$t('OrderCurrent.province.QC')}}</option>
              <option value="SK">{{$t('OrderCurrent.province.SK')}}</option>
              <option value="YT">{{$t('OrderCurrent.province.YT')}}</option>
            </regular-select>
            <regular-input
              :value="newCustomView.dateReceptionMin"
              @input="newCustomView.dateReceptionMin = $event"
              type="date" placeholder="Date min" class="col-12 col-sm-6 form-group"/>
            <regular-input
              :value="newCustomView.dateReceptionMax"
              @input="newCustomView.dateReceptionMax = $event"
              type="date" placeholder="Date max" class="col-12 col-sm-6 form-group"/>
            <regular-input
              :value="newCustomView.afterXDays"
              @input="newCustomView.afterXDays = $event"
              type="number" :placeholder="$t('OrderCurrent.modal.after_x_days')" class="col-12 col-sm-6 form-group"/>
            <regular-input
              :value="newCustomView.beforeXDays"
              @input="newCustomView.beforeXDays = $event"
              type="number" :placeholder="$t('OrderCurrent.modal.before_x_days')" class="col-12 col-sm-6 form-group"/>
            <div class="col-12">
              <button class="btn btn-kne-orange w-100" :disabled="newCustomView.name === ''" @click="addCustomView()">
                {{$t('OrderCurrent.modal.confirm')}}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <!-- Print vin -->
      <modal
        v-if="vinPrinting"
        :title="$t('OrderCurrent.modal.printVin.title')"
        @close-request="vinPrinting=false; clear()"
        closable
      >
      <div id="vinPrint">
        <table-element
          :title="$t('OrderCurrent.modal.selected_orders')"
          :arrOfElement="selectedFull"
          :fields="fieldsObjVIN"
          :isShowFilter="false"
          :isShowSelectAll="false"
          :hideTitleonPrint=this.hideTitleonPrint
          :sortSpacing="0"
          class="mx-2 mt-4"
        >

          <template #header-actions>
            <p class="m-2 mb-0 mt-2">{{$t('OrderCurrent.count')}} {{selected.length}}</p>
          </template>

          <template #pre-body-content>
            <div class="preBody" style="display: flex; justify-content: space-between;">
              <img id='logo' :src="user.logo" class="" style="width: 100; height: 100; margin-right: 200px;">
              <div class="address-info" style="display: flex; flex-direction: column;">
                <h3 style="margin-bottom: 0.3em; margin-top: 1em;">{{user.name}}</h3>
                <p style="margin-bottom: 0.1em; word-wrap: break-word; overflow-wrap: break-word;">{{ user.address }}</p>
                <p style="margin-bottom: 0.1em;">{{ user.city }}, {{ user.province }}, {{ user.postcode }}</p>
                <p style="margin-bottom: 0.1em;">Phone: {{user.phone}}</p>
                <p style="margin-bottom: 0.6em;">Fax: {{user.fax }}</p>
              </div>
            </div>
          </template>

          <template #body-content-desktop="content">
            <!-- List of orders -->
            <tr v-for="(order, index) in content.results"
            class="table-element_hover text-center"
            :key="index">
              <td>
                {{order.orderNumber}}
              </td>
              <td>
                <barcode :value="order.vin" format="CODE128A" >
                  {{$t('OrderCurrent.modal.printVin.noVin')}}
                </barcode>
              </td>
              <td>
                {{order.make}}
              </td>
              <td>
                {{order.model}}
              </td>
              <td>
                {{order.year}}
              </td>
              <td>
                {{order.numRef || '-'}}
              </td>
              <td>
                {{$realName(order, 'transmitter')}}
              </td>
              <td>
                {{$realName(order, 'receiver')}}
              </td>
            </tr>
          </template>

          <template #post-body-content>
            <div class="mt-2">
              <button class="btn btn-kne-orange float-right m-1" @click="sendToPrint()">{{$t('OrderCurrent.actions.printVin')}}</button>
            </div>
          </template>

        </table-element>
      </div>
      </modal>

      <!-- View deletion -->
      <modal
        :title="$t('OrderCurrent.sidebar.delete_custom_view')"
        v-if="modal.deleteCustomView"
        @close-request="modal.deleteCustomView = false; clear()"
        closable>

        <div class="container-fluid">
          <div class="row">
            <regular-select
              :value="selectedCustomView"
              @change="selectedCustomView = $event"
              :placeholder="$t('OrderCurrent.modal.custom_view')" class="col-12 form-group">
              <option v-for="(view, index) in customViews" :key="index" :value="view['.key']">{{view.query.name}}</option>
            </regular-select>
            <div class="col-12">
              <div class="pull-right">
                <button class="btn btn-kne-orange" :disabled="selectedCustomView === ''" @click="deleteCustomView()">
                  {{$t('OrderCurrent.modal.confirm')}}
                </button>
                <button class="btn btn-danger" @click="modal.deleteCustomView = false">
                  {{$t('OrderCurrent.modal.cancel')}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </modal>

      <!-- Optimize route -->
      <modal
      v-if="this.modal.directions"
      :title="$t('Zone.optimizeRoute')"
      @close-request="modal.directions = false; clear()"
      closable
      >
        <div class="kne-modal">
          <div class="content-container m-2" :class="{'content-container-mobile' : isScreenSmall}">  <!-- Whole modal container -->
            <div class="modal-misc"> <!-- Miscellaneous modal actions -->
              <div class="misc-content">  <!-- Misc sub-container (Left-side)-->
                <regular-datalist
                    :value="mapLocDatalist"
                    @input="setAndSearch($event, 'mapDirection')"
                    :originalList="$store.state.allContacts"
                    :secondList="isSageOne ? hasProvince : addressbook"
                    :placeholder="$t('AddressBook.title')" class="mb-2"
                    @focus="onFocus()"/>
                <div>
                  <vue-google-autocomplete
                    class="form-control input-special my-1"
                    id="mapDirectionLocation"
                    ref="AutocompleteSearchMapDirection"
                    :placeholder="$t('AddressBook.search_autocomplete')"
                    v-on:placechanged="updateMapLocationVGA"
                    :country="['ca', 'us']"
                    :fields="autocompleteSearchFields">
                  </vue-google-autocomplete>
                  <button class="border btn my-1 mx-0" @click="updateMapLocation({},'USER')">{{$t('Zone.userLocation')}}</button>
                </div>

                <div class="mt-3 overflow">

                  <!-- Start -->
                  <button
                    :class="{'border unfocused' : mapDestinationToggle !== false}"
                    class="btn modal-misc__btn--width modal-misc__btn--focused modal-misc__btn--false my-1 mx-0 px-1"
                    @click="switchDestinationField(false)">
                    <span v-if="mapDestinationStart === ''" >{{$t('Zone.origin')}}</span>
                    <span v-else>{{mapDestinationStart}}</span>
                  </button>

                  <!-- Waypoints -->
                  <button
                    :class="{'border unfocused' : mapDestinationToggle !== null}"
                    class="btn modal-misc__btn--width modal-misc__btn--focused modal-misc__btn--null mt-1 mx-0 px-0 "
                    @click="switchDestinationField(null)">{{$t('Zone.waypoints')}}
                    <button class="waypt-refresh-button border" @click="resetWaypoints()"><i class="fa fa-refresh" aria-hidden="true" /></button>
                  </button>
                  <div :class="{'border unfocused' : mapDestinationToggle !== null}" class="border modal-misc__waypt-list text--center mb-1">
                    <div v-for="(waypoints, index) in mapWaypoints" :key="index" class="overflow">
                      <span>{{waypoints.location}}</span>
                    </div>
                  </div>

                  <!-- End -->
                  <button
                    :class="{'border unfocused' : mapDestinationToggle !== true}"
                    class="btn modal-misc__btn--width modal-misc__btn--focused modal-misc__btn--true my-1 mx-0 px-1 overflow"
                    @click="switchDestinationField(true)">
                    <span v-if="mapDestinationEnd === ''" >{{$t('Zone.destination')}}</span>
                    <span v-else>{{mapDestinationEnd}}</span>
                  </button>


                  <div class="mt-3">
                    <!-- Set GoogleRequest parameters -->
                    <div>
                      <button :class="{'border unfocused unfocusedV2' : isFerries === true}" class="modal-misc__btn--focusedV2 btn my-1 mx-0" @click="setGoogleRequestParameters('SHIP')"><i class="fa fa-ship" /></button>
                      <button :class="{'border unfocused unfocusedV2' : isHighways === true}" class="modal-misc__btn--focusedV2 btn my-1 mx-0" @click="setGoogleRequestParameters('HIGHWAY')"><i class="fa fa-road" /></button>
                      <button :class="{'border unfocused unfocusedV2' : isTolls === true}" class="modal-misc__btn--focusedV2 btn my-1 mx-0" @click="setGoogleRequestParameters('TOLL')"><i class="fas fa-hand-holding-usd" /></button>
                    </div>

                    <div>
                      <!-- Render path on map -->
                      <button
                      :disabled="mapDestinationStart === '' || mapDestinationEnd === ''"
                      class="btn btn-kne-orange my-1 border"
                      @click="createMapPath(mapDestinationStart, mapDestinationEnd)">{{$t('Zone.createPath')}}</button>
                    </div>
                  </div>

                  <!-- Confirm path -->
                  <div class="text--center mt-3">
                    <button :disabled="mapUrl === ''" class="btn btn-kne-orange my-1 border" @click="pushMapUrl()">{{$t('Zone.confirmPath')}}</button>
                  </div>

                  <!-- Show list of MapUrls -->
                  <div class="border text--center">
                    <span v-if="mapUrlList.length <= 0">{{$t('Zone.linkPending')}}</span>

                    <div v-else v-for="(map, index) in mapUrlList" :key="index" class="border-radius-none border display--flex">
                      <button class="btn btn-kne-red border border-radius-none unfocused" @click="deleteMapUrl(index)">X</button>
                      <a :href="map.mapUrl" target="_blank" class="modal-misc__mapUrl--focused overflow">
                        <span>{{map.mapUrl}}</span>
                      </a>
                    </div>

                    <div v-if="mapUrlList.length > 0" class="border display--flex">
                      <regular-datalist-driver
                        :value="mapUrlDriver"
                        @input="setAndSearch($event, 'mapUrlDriver')"
                        :secondList="liste"
                        :placeholder="$t('Search.driver')"
                        class="border-radius-none" style="width: 100%;"/>
                        <button :disabled="mapUrlDriver === ''"
                          class="btn-kne-orange border-radius-none border"
                          @click="sendMapUrl()">
                          <i class="fas fa-envelope mx-2" />
                        </button>
                    </div>

                  </div>
                </div>
              </div>
            </div>  <!-- Miscellaneous modal actions END -->

            <div class="mx-2 card modal-location">
              <div class="table-responsive">
                <table class="table table-hover font-grey mb-0 table-sm">
                  <thead class="bg-darkgrey">
                    <tr>
                      <th>{{$t('OrderCurrent.order')}}</th>
                      <th>{{$t('OrderCurrent.pickup')}}</th>
                      <th>{{$t('Zone.currentLocation')}}</th>
                      <th>{{$t('OrderCurrent.delivery')}}</th>
                    </tr>
                  </thead>
                  <transition-group name="fade" tag="tbody">
                    <tr v-for="(order, index) in selectedFull" :key="index" class="m-1 p-2">
                      <td><span>{{selected[index]}}</span></td>
                      <td><button class="btn border" @click="updateMapLocation(order, 'PICKUP')">{{$realName(order, 'transmitter')}}</button></td>
                      <td><button class="btn border" @click="updateMapLocation(order, 'CURRENT')">{{$t('Zone.vehicle')}}</button></td>
                      <td><button class="btn border" @click="updateMapLocation(order, 'DROP')">{{$realName(order, 'receiver')}}</button></td>
                    </tr>
                  </transition-group>
                </table>
              </div>
            </div>

            <!-- MAP CONTAINER -->
            <div class="modal-map text--center mr-3">
              <div class="border" :class="{'mobile-map' : isScreenSmall}"> <!-- Modal map -->
                <div class="kne-title card-header">
                  <h4 class="my-2">{{$t('Zone.path')}}</h4>
                </div>
                <gmap-map
                    id="directionMap"
                    :center="center"
                    :zoom="8"
                    style="width:100%; height: 450px;">
                  <GmapCluster
                    :position="center"
                    :clickable="true"
                    :animation="2"
                    :minimumClusterSize="5"
                    :gridSize="30"
                    :zoomOnClick="true"
                    :enableRetinaIcons="true"
                    :maxZoom="zoom">
                    <gmap-marker
                      :clickable="true"
                      :position="center"
                      @click="toggleInfoWindow(item, index)">
                    </gmap-marker>
                    <gmap-info-window
                      :options="infoOptions"
                      :position="infoWindowPos"
                      :opened="infoWinOpen"
                      @closeclick="infoWinOpen=false">
                      <div v-html="infoContent"></div>
                    </gmap-info-window>
                  </GmapCluster>
                </gmap-map>
              </div> <!-- Modal Map -->

              <div class="border text--center display--flex mt-2">
                <div>
                  <span class="mr-3">{{formattedDistance}}KM <i class="fa fa-route" /></span>
                  <span>{{formattedDurationH}}H </span>
                  <span>{{formattedDurationM}}M <i class="fa fa-clock" /></span>
                </div>
              </div>
            </div> <!-- MAPS CONTAINER END -->


          </div> <!-- Modal container END -->
        </div>
      </modal>

    </transition>
  </div>
</template>

<script>
  import Modal from '../module/interface-components/Modal.vue'
  import regularInput from '../module/basic-components/regularInput.vue'
  import printJS from 'print-js'
  import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
  import regularTextarea from '../module/basic-components/regularTextarea.vue'
  import regularSelect from '../module/basic-components/regularSelect.vue'
  import regularInputNumber from '../module/basic-components/regularInputNumber.vue'
  import hoverToolTip from '../module/basic-components/hoverToolTip.vue'
  import Search from '../module/special-components/Other-components/Search.vue'
  import regularDatalistDriver from '../module/basic-components/regularDatalistDriver.vue'
  import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
  import VueGoogleAutocomplete from 'vue-google-autocomplete'
  import DeliveryLocationDetails from '../module/special-components/Other-components/DeliveryLocationDetails.vue'
  import OrderStatusCounter from '../module/special-components/Other-components/OrderStatusCounter.vue'
  import DistributedHistoryModal from '../module/special-components/Modal-templates/DistributedHistory-modal.vue'
  import DeliveryLocationModal from '../module/special-components/Modal-templates/DeliveryLocation-modal.vue'
  import TableElement from '../module/special-components/Table-component/Table-Element.vue'
  import ShortDispatchModal from '../module/special-components/Modal-templates/ShortDispatch-modal.vue'
  import LateTimeExtensionModal from '../module/special-components/Modal-templates/LateTimeExtension-modal.vue'
  import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
  import FilterZonesModal from '../module/special-components/Modal-templates/FilterZones-modal.vue'
  import StatusChangeModal from '../module/special-components/Modal-templates/StatusChange-modal.vue'
  import DeliveryOrderModal from '../module/special-components/Modal-templates/DeliveryOrder-modal.vue'
  import {db, dbMapUrl} from '../../firebase'
  // import _ from 'lodash'
  import JsonExcel from 'vue-json-excel'
  import GoogleMap from '../module/special-components/Other-components/GoogleMap.vue'
  import { gmapApi } from 'vue2-google-maps'
  import * as turf from '@turf/turf'
  import { isRegularOrder } from '@/inventory/inventorySelectors'

  export default {
    name: 'zone',
    components: {
      LoadingRender,
      DeliveryLocationDetails,
      Modal,
      GoogleMap,
      regularInput,
      regularCheckbox,
      regularTextarea,
      regularSelect,
      regularInputNumber,
      hoverToolTip,
      Search,
      regularDatalistDriver,
      StatusChangeModal,
      JsonExcel,
      SidebarToggleButton,
      VueGoogleAutocomplete,
      OrderStatusCounter,
      DistributedHistoryModal,
      DeliveryLocationModal,
      TableElement,
      ShortDispatchModal,
      LateTimeExtensionModal,
      FilterZonesModal,
      DeliveryOrderModal
    },

    data () {
      return {
        customers_fields: {
          'Commande': 'order',
          'Référence': 'numRef',
          'source': 'source',
          'VIN': 'vin',
          'Date': {
            field: 'creationDate',
            callback: (value) => {
              return this.formatDate(value)
            }
          },
          'Cueillette': 'transmitterName',
          'Livraison': 'receiverName',
          'Facturation': 'payerName',
          'status': 'status',
          'Chauffeur': 'driverName',
          'Province de cueillette': 'provincePick',
          'Province de livraison': 'provinceDrop',
          'Remarque': 'remark'
        },
        shortDispatch: false,
        dispatchOrder: {
        chauffeur: '',
        chauffeurName: ''
      },
        VIN: '',
        MAKE: '',
        MODEL: '',
        YEAR: '',
        vehicles: [],
        isPickupOpen: true,
        isDestinationOpen: true,
        pickupSave: false,
        deliverySave: false,
        billingSame: false,
        user: {
          name: '',
          address: '',
          city: '',
          zipCode: '',
          province: '',
          phone: '',
          nir: '',
          cigle: '',
          logo: ''
        },
        order: {
          comment: '',
          docs: false,
          latitude: 0.001,
          longitude: 0.001,
          make: '',
          model: '',
          nbDispatch: 0,
          numRef: '',
          payer: '',
          payerAddress: '',
          payerCity: '',
          payerContact: '',
          payerFax: '',
          payerName: '',
          payerPhone: '',
          payerEmail: '',
          payerPostcode: '',
          payerCountry: '',
          payerProvince: '',
          price: '',
          billNum: '',
          receiver: '',
          receiverAddress: '',
          receiverCity: '',
          receiverContact: '',
          receiverFax: '',
          receiverLat: 0,
          receiverLong: 0,
          receiverName: '',
          receiverPhone: '',
          receiverEmail: '',
          receiverPostcode: '',
          receiverCountry: '',
          receiverProvince: '',
          status: 'Processing',
          source: '',
          datePromis: '',
          sageID: '',
          transmitter: '',
          transmitterAddress: '',
          transmitterCity: '',
          transmitterContact: '',
          transmitterFax: '',
          transmitterLat: 0,
          transmitterLong: 0,
          transmitterName: '',
          transmitterPhone: '',
          transmitterEmail: '',
          transmitterPostcode: '',
          transmitterCountry: '',
          transmitterProvince: '',
          transpCigle: '',
          transpName: '',
          vin: '',
          year: ''
        },
        vinPrinting: false,
        isStatusEdit: false,
        hideTitleonPrint: false,
        feedbackMessage: '',
        datalist: {
          pickup: '',
          pickupUid: '',
          delivery: '',
          deliveryUid: '',
          billing: '',
          billingUid: ''
        },
        closedModal: true,
        fields: {
          '.key': '',
          numRef: '',
          source: '',
          vin: '',
          datePromis: '',
          docs: '',
          creationDate: '',
          receiverName: '',
          transmitterName: '',
          payerName: '',
          status: '',
          driverName: ''
        },
        backup: {
          sageIDDelivery: ''
        },
        filterResults: [],
        processing: [],
        addressbook: [],
        selected: [],
        selectedFull: [],
        modal: {
          newCustomView: false,
          deleteCustomView: false,
          directions: false
        },
        newCustomView: {
          name: '',
          VIN: '',
          referenceNumber: '',
          source: '',
          pickup: '',
          delivery: '',
          billing: '',
          status: '',
          dateReceptionMin: '',
          dateReceptionMax: '',
          driver: '',
          afterXDays: '',
          beforeXDays: '',
          provincePick: '',
          provinceDrop: ''
        },
        customViews: [],
        center: { lat: 45.508, lng: -73.587 },
        infoWindow: {
          posOrigin: {lat: 0, lng: 0},
          open: false,
          template: ''
        },
        infoWindow2: {
          posDestination2: {lat: 0, lng: 0},
          open: false,
          template: ''
        },
        infoWindow3: {
          posCurrent3: {lat: 0, lng: 0},
          open: false,
          template: ''
        },
        markers: [{
          fullOrder: [],
          posOrigin: {lat: 39.933049, lng: 32.858912},
          posDestination2: {lat: 39.933049, lng: 32.858912},
          posCurrent3: {lat: 39.933049, lng: 32.858912}
        }],
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        infoWindowPos2: {
          lat: 0,
          lng: 0
        },
        infoWindowPos3: {
          lat: 0,
          lng: 0
        },
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
        infoContent: 'ab',
        infoWinOpen: false,
        places: [],
        places2: [],
        places3: [],
        currentPlace: null,
        currentPlace2: null,
        currentPlace3: null,
        selectedCustomView: '',
        zoom: 12,
        searchHistory: [],
        searchType: '',
        searchText: '',
        historyTypeTag: '',
        autocompleteSearchFields: ['address_components', 'adr_address', 'formatted_address', 'formatted_phone_number', 'geometry', 'id', 'name', 'place_id', 'type', 'vicinity'],
        // 'utc_offset_minutes', 'url', 'photo', 'business_status', 'icon', 'scope', 'alt_id',
        vueGoogleAutocomplete: false,
        badVin: false, // New Order, invalid VIN check,
        greenCar: '/static/car-green.png', // Green car
        orangeCar: '/static/car-orange.png', // Orange car
        redCar: '/static/car-red.png', // Red car
        defaultCar: '/static/car-default.png', // Default car
        greenOrderDayLimit: 2, // Day limit for green orders
        orangeOrderDayLimit: 4, // Day limit for orange orders
        redOrderDayLimit: 6, // Day limit for red orders
        mapDestinationStart: '',
        mapDestinationEnd: '',
        mapDestinationToggle: false, // Determines if Origin (false), Waypoint (null) or Destination (true) marker is being changed
        mapLocDatalist: '',
        mapLocDatalistUid: '',
        mapUrl: '',
        map: {},
        mapUrlList: [],
        mapUrlDriver: '',
        mapUrlDriverUid: '',
        mapWaypoints: [],
        isFerries: true,
        isHighways: false,
        isTolls: true,
        formattedDistance: 0,
        formattedDurationH: 0,
        formattedDurationM: 0,
        isLoading: true,
        priceOrderLink: [], // This is to create a price/order link list for dispatches
        errorMessage: '',
        areAllOrdersSelected: false,
        isDistributedModal: false,
        isDeliveryLocationModal: false,
        selectedOrder: {},
        greenCarCount: 0,
        orangeCarCount: 0,
        redCarCount: 0,
        defaultCarCount: 0,
        fieldsObj: [
          {
            text: `<i class="fa fa-solid fa-clipboard" />`,
            type: 'survey',
            value: ''
          },
          {
            text: this.$t('OrderCurrent.order'),
            type: '.key',
            value: ''
          },
          {
            text: this.$t('OrderCurrent.date'),
            type: 'creationDate',
            value: ''
          },
          {
            text: this.$t('OrderCurrent.modal.carInfo.model'),
            type: 'model',
            value: ''
          },
          {
            text: this.$t('OrderCurrent.VIN'),
            type: 'vin',
            value: ''
          },
          {
            text: this.$t('OrderCurrent.pickup'),
            type: 'transmitterName',
            value: ''
          },
          {
            text: this.$t('OrderCurrent.delivery'),
            type: 'receiverName',
            value: ''
          },
          {
            text: this.$t('OrderCurrent.billing'),
            type: 'payerName',
            value: ''
          },
          {
            text: this.$t('OrderCurrent.status'),
            type: 'status',
            value: ''
          },
          {
            text: this.$t('OrderCurrent.driver'),
            type: 'driverName',
            value: ''
          }
        ],
        fieldsObjVIN: [
      {
         text: this.$t('OrderCurrent.order'),
         type: '.key',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.VIN'),
         type: 'vin',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.modal.carInfo.make'),
         type: 'make',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.modal.carInfo.model'),
         type: 'model',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.modal.carInfo.year'),
         type: 'model',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.reference'),
         type: 'numRef',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.pickup'),
         type: 'transmitterName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.delivery'),
         type: 'receiverName',
         value: ''
       }
      ],
        isShortDispatchModal: false,
        isLegend: false,
        zones: [],
        zoneOptions: [],
        currentDrawingManager: {},
        destinationDrawingManager: {},
        polygons: {
          'current': null,
          'destination': null
        },
        pickZones: [],
        dropZones: [],
        filteredPickZones: [],
        filteredDropZones: [],
        originalProcessing: [],
        driverName: '',
        showFilterZonesModal: false,
        driversDispatchOrders: [],
        isDeliveryOrderModal: false,
        driverLocation: {},
        lateTimeExtension: false,
        disableDefaultSort: true,
        enableDriversSort: false,
        ordersListener: null,
        lateOrdersPresent: false,
        processDeliveriesToken: 0,
        wallFileCacheId: '',
        wallFileCache: null,
        currentPolygonCompleteListener: null,
        currentPathSetAtListener: null,
        currentPathInsertAtListener: null,
        currentPathRemoveAtListener: null,
        destinationPolygonCompleteListener: null,
        destinationPathSetAtListener: null,
        destinationPathInsertAtListener: null,
        destinationPathRemoveAtListener: null
      }
    },

    created () {
      this.$store.state.isSidebarOpen = false
      this.isScreenSmall = window.innerWidth < 800
      this.filterOrders()

      // Use store deliveries instead of direct Firebase listener
      if (!this.$store.state.deliveriesLoaded) {
        this.$store.dispatch('subscribeToDeliveries')
      }
      this.processDeliveries()

      if (this.driversFile) {
        this.fieldsObj.push({
          text: 'Delivery order',
          type: 'deliveryOrder',
          value: ''
        })
      }

      this.getZones()
      this.initializeDrawingManager()
      // this.$bindAsArray('pending', db.ref('database/transporter/' + this.companyUID + '/unprocessed'))
      this.$bindAsArray('liste', db.ref('database/transporter/' + this.companyUID + '/liste'))
      this.$bindAsArray('customViews', db.ref('database/transporter/' + this.companyUID + '/customViewsZone'))
    },

    methods: {
      async processDeliveries () {
        const requestToken = ++this.processDeliveriesToken
        const wallFileId = this.$route.query.wallFileId
        const data = this.$store.state.deliveries.filter(isRegularOrder)

        if (!data || data.length === 0) {
          this.processing = []
          this.originalProcessing = []
          this.lateOrdersPresent = false
          if (this.$store.state.deliveriesLoaded) {
            this.isLoading = false
          }
          return
        }

        if (this.driversFile) {
          this.filterOrdersForDriver(data)
          if (this.driverStatus) {
            this.driverLocation = {
              lat: this.driverStatus.latitude,
              lng: this.driverStatus.longitude
            }
          }
        } else if (this.wallFile) {
          this.filterOrdersForWallFile(this.wallFileOrders)
        } else if (this.clientsFile) {
          this.filterOrdersForClient(data)
        } else if (wallFileId) {
          const wallFile = await this.getWallFileById(wallFileId)
          if (requestToken !== this.processDeliveriesToken) return

          if (!wallFile) {
            this.processing = []
          } else {
            const filteredData = data.filter(order =>
              this.isOrderInWallfile(order, wallFile)
            )

            this.processing = filteredData.filter(order => (
                (order.status !== 'Drop' ||
                  (order.status === 'Drop' && order.historySync && order.receiverAddress === this.lastHistorySync(order.historySync, 'receiverAddress'))
                ) && (order.status !== 'Pick' ||
                  (order.status === 'Pick' && order.historySync && order.transmitterAddress === this.lastHistorySync(order.historySync, 'transmitterAddress'))
                )
              )
            )
          }
        } else {
          this.processing = data.filter(order => order.status !== 'to cancel' && order.status !== 'to finish')
        }

        if (requestToken !== this.processDeliveriesToken) return
        this.validateLateOrders()
        this.isLoading = false
        this.originalProcessing = [...this.processing]
      },
      async getWallFileById (wallFileId) {
        if (!wallFileId) return null
        if (this.wallFileCacheId === wallFileId) return this.wallFileCache

        const snapshot = await db.ref('database/wallfiles/transporter')
          .child(this.companyUID)
          .child('wallfile')
          .child(wallFileId)
          .once('value')

        const wallFile = snapshot.val() || null
        this.wallFileCacheId = wallFileId
        this.wallFileCache = wallFile

        return wallFile
      },
      async initializeDrawingManager () {
        if (!this.google || !this.$refs.map || !this.$refs.destinationMap) {
          setTimeout(this.initializeDrawingManager, 100)
          return
        }
        this.map = this.$refs.map.$mapObject
        this.destinationMap = this.$refs.destinationMap.$mapObject

        // if (this.lateOrdersPresent) return

        const drawingManagerOptions = {
            drawingMode: null,
            drawingControl: true,
            drawingControlOptions: {
              position: this.google.maps.ControlPosition.TOP_CENTER,
              drawingModes: [this.google.maps.drawing.OverlayType.POLYGON]
            },
            polygonOptions: {
              fillColor: '#BCDCF9',
              fillOpacity: 0.35,
              strokeWeight: 3,
              strokeColor: '#57ACF9',
              clickable: false,
              editable: true,
              zIndex: 1
            }
          }

        this.currentDrawingManager = new this.google.maps.drawing.DrawingManager(drawingManagerOptions)
        this.currentDrawingManager.setMap(this.map)

        this.destinationDrawingManager = new this.google.maps.drawing.DrawingManager(drawingManagerOptions)
        this.destinationDrawingManager.setMap(this.destinationMap)

        const clearButtonStyles = {
          backgroundColor: 'white',
          border: '2px solid #ccc',
          borderRadius: '3px',
          boxShadow: '0 2px 6px rgba(0,0,0,.3)',
          cursor: 'pointer',
          marginRight: '10px',
          marginTop: '5px',
          padding: '4px 10px',
          fontSize: '14px'
        }

        const clearButton = document.createElement('button')
        clearButton.textContent = 'Clear'
        Object.assign(clearButton.style, clearButtonStyles)
        clearButton.onclick = this.clearCurrentPolygon
        this.map.controls[this.google.maps.ControlPosition.TOP_CENTER].push(clearButton)

        const destClearButton = document.createElement('button')
        destClearButton.textContent = 'Clear'
        Object.assign(destClearButton.style, clearButtonStyles)
        destClearButton.onclick = this.clearDestinationPolygon
        this.destinationMap.controls[this.google.maps.ControlPosition.TOP_CENTER].push(destClearButton)

        this.currentPolygonCompleteListener = this.google.maps.event.addListener(this.currentDrawingManager, 'polygoncomplete', (polygon) => {
          this.clearCurrentPolygon()
          this.handlePolygonChange(polygon)
          this.currentPathSetAtListener = this.google.maps.event.addListener(polygon.getPath(), 'set_at', () => {
            this.handlePolygonChange(polygon)
          })
          this.currentPathInsertAtListener = this.google.maps.event.addListener(polygon.getPath(), 'insert_at', () => {
            this.handlePolygonChange(polygon)
          })
          this.currentPathRemoveAtListener = this.google.maps.event.addListener(polygon.getPath(), 'remove_at', () => {
            this.handlePolygonChange(polygon)
          })
        })

        this.destinationPolygonCompleteListener = this.google.maps.event.addListener(this.destinationDrawingManager, 'polygoncomplete', (polygon) => {
          this.clearDestinationPolygon()
          this.handleDestinationPolygonChange(polygon)
          this.destinationPathSetAtListener = this.google.maps.event.addListener(polygon.getPath(), 'set_at', () => {
            this.handleDestinationPolygonChange(polygon)
          })
          this.destinationPathInsertAtListener = this.google.maps.event.addListener(polygon.getPath(), 'insert_at', () => {
            this.handleDestinationPolygonChange(polygon)
          })
          this.destinationPathRemoveAtListener = this.google.maps.event.addListener(polygon.getPath(), 'remove_at', () => {
            this.handleDestinationPolygonChange(polygon)
          })
        })
      },
      isOrderInWallfile (order, wallfile) {
        if (!order.transmitterLat || !order.transmitterLong || !order.receiverLat || !order.receiverLong) {
          return false
        }

        const pickPoint = turf.point([parseFloat(order.transmitterLong), parseFloat(order.transmitterLat)])
        const dropPoint = turf.point([parseFloat(order.receiverLong), parseFloat(order.receiverLat)])

        let isInPickZone = false
        let isInDropZone = false

        if (wallfile.customPickZones) {
          isInPickZone = wallfile.customPickZones.some(zoneData => {
            if (!zoneData.coordinates || zoneData.coordinates.length < 3) return false
            const coords = [...zoneData.coordinates]
            if (coords[0] !== coords[coords.length - 1]) coords.push(coords[0])
            const polygon = turf.polygon([coords])
            return turf.booleanPointInPolygon(pickPoint, polygon)
          })
        }

        if (wallfile.customDropZones) {
          isInDropZone = wallfile.customDropZones.some(zoneData => {
            if (!zoneData.coordinates || zoneData.coordinates.length < 3) return false
            const coords = [...zoneData.coordinates]
            if (coords[0] !== coords[coords.length - 1]) coords.push(coords[0])
            const polygon = turf.polygon([coords])
            return turf.booleanPointInPolygon(dropPoint, polygon)
          })
        }

        return isInPickZone && isInDropZone
      },
      lastHistorySync (obj, key) {
        // Check if obj is null or undefined
        if (!obj || typeof obj !== 'object') {
          return null
        }
        const lastKey = Object.keys(obj)
          .sort((a, b) => {
            const numA = parseInt(a.split('-')[1], 10)
            const numB = parseInt(b.split('-')[1], 10)
            return numA - numB
          })
          .pop()
        if (lastKey && obj[lastKey] && obj[lastKey][key]) {
          return obj[lastKey][key]
        } else {
          return null
        }
      },
      toggleMap (toggle) {
        if (toggle === 'pick') {
          this.isPickupOpen = !this.isPickupOpen
        } else {
          this.isDestinationOpen = !this.isDestinationOpen
        }
      },
      fetchOrdersByIds (orderIds) {
        if (!orderIds || orderIds.length === 0) {
          return
        }

        // Clean up existing listeners first
        this.cleanupOrderListeners()

        // Store listener references for cleanup
        this.orderListeners = []

        // Set up reactive listeners for each order
        orderIds.forEach(orderId => {
          if (!orderId) return

          const orderRef = db.ref('database/transporter')
            .child(this.companyUID)
            .child('deliveries')
            .child(orderId)

          // Create reactive listener
          const listener = orderRef.on('value', (snapshot) => {
            const order = snapshot.val()

            if (order) {
              order['.key'] = orderId
              order.orderNumber = orderId

              // Update the processing array reactively
              this.updateProcessingOrder(orderId, order)
            } else {
              // Order was deleted, remove from processing
              this.removeProcessingOrder(orderId)
            }
          }, (error) => {
            console.error(`Error listening to order ${orderId}:`, error)
          })

          // Store reference for cleanup
          this.orderListeners.push({ ref: orderRef, listener })
        })
      },

      // Helper method to update a specific order in the processing array
      updateProcessingOrder (orderId, updatedOrder) {
        if (!isRegularOrder(updatedOrder)) {
          this.removeProcessingOrder(orderId)
          return
        }

        const index = this.processing.findIndex(order => order['.key'] === orderId)

        if (index !== -1) {
          // Update existing order
          this.$set(this.processing, index, updatedOrder)
        } else {
          // Add new order
          this.processing.push(updatedOrder)
        }
      },

      // Helper method to remove an order from processing array
      removeProcessingOrder (orderId) {
        const index = this.processing.findIndex(order => order['.key'] === orderId)
        if (index !== -1) {
          this.processing.splice(index, 1)
        }
      },

      // Clean up all order listeners
      cleanupOrderListeners () {
        if (this.orderListeners) {
          this.orderListeners.forEach(({ ref, listener }) => {
            ref.off('value', listener)
          })
          this.orderListeners = []
        }
      },

      handlePolygonChange (polygon) {
        let polygonArr = []
        for (let i = 0; i < polygon.getPath().getLength(); i++) {
          let point = [
            polygon.getPath().getAt(i).lng(),
            polygon.getPath().getAt(i).lat()
          ]
          polygonArr.push(point)
        }
        polygonArr.push(polygonArr[0])
        polygon.turfPolygon = polygonArr
        this.polygons.current = polygon
        this.filterOrdersForPolygons()
      },

      async filterOrdersForPolygons () {
        this.clearZonesFilter()
        if (!this.polygons.current && !this.polygons.destination) {
          this.processing = this.originalProcessing
          return
        }
        this.processing = await this.originalProcessing.filter(order => {
          const currentLat = this.offsetMapMarkerValue(order.latitude)
          const currentLong = this.offsetMapMarkerValue(order.longitude)
          const destinationLat = this.offsetMapMarkerValue(order.receiverLat)
          const destinationLong = this.offsetMapMarkerValue(order.receiverLong)
          if (!currentLat || !currentLong || !destinationLat || !destinationLong) return false
          const currentPoint = turf.point([
            currentLong,
            currentLat
          ])
          const destinationPoint = turf.point([
            destinationLong,
            destinationLat
          ])
          if (this.polygons.current && this.polygons.destination) {
            return (turf.booleanPointInPolygon(currentPoint, turf.polygon([this.polygons.current.turfPolygon])) &&
             turf.booleanPointInPolygon(destinationPoint, turf.polygon([this.polygons.destination.turfPolygon])))
          } else if (this.polygons.current) {
            return turf.booleanPointInPolygon(currentPoint, turf.polygon([this.polygons.current.turfPolygon]))
          } else if (this.polygons.destination) {
            return turf.booleanPointInPolygon(destinationPoint, turf.polygon([this.polygons.destination.turfPolygon]))
          }
          return false
        })
      },

      sendToPrint () {
        this.hideTitleonPrint = true
        setTimeout(() => {
          // Trigger the print using print-js
          printJS({
            printable: 'vinPrint',
            type: 'html',
            scanStyles: false // Set to true if you want to include styles in the print
          })

          // Clear selected data
          this.clearSelected()

          // Reset hideTitleonPrint
          this.hideTitleonPrint = false // Restore after printing
        }, 100)// Delay in milliseconds (adjust as necessary)
      },
      handleDestinationPolygonChange (polygon) {
        let polygonArr = []
        for (let i = 0; i < polygon.getPath().getLength(); i++) {
          let point = [
            polygon.getPath().getAt(i).lng(),
            polygon.getPath().getAt(i).lat()
          ]
          polygonArr.push(point)
        }
        polygonArr.push(polygonArr[0])
        polygon.turfPolygon = polygonArr
        this.polygons.destination = polygon
        this.filterOrdersForPolygons()
      },

      clearCurrentPolygon (data = false) {
        if (this.polygons.current) {
          this.polygons.current.setMap(null)
          this.polygons.current = null
        }
        if (data !== 'filterZonesModal') this.filterOrdersForPolygons()
      },

      clearDestinationPolygon (data = false) {
        if (this.polygons.destination) {
          this.polygons.destination.setMap(null)
          this.polygons.destination = null
        }
        if (data !== 'filterZonesModal') this.filterOrdersForPolygons()
      },

      filterOrdersForWallFile (data) {
        // this.processing = data.filter(order => {
        //   return !((this.passedPickZones && this.passedPickZones.length && !this.passedPickZones.includes(order.transmitterZoneId) ||
        //   this.passedDropZones && this.passedDropZones.length && !this.passedDropZones.includes(order.receiverZoneId)))
        // })
        this.processing = Array.isArray(data) ? data.filter(isRegularOrder) : []
      },

      filterOrdersForClient (data) {
        this.processing = data.filter(order => this.clientsFile.client === order.payer)
      },

      filterOrdersForDriver (data) {
        this.processing = data.filter(order => {
          if (!order.historySync) return false
          const keys = Object.keys(order.historySync)
          const lastKey = keys[keys.length - 1]
          const driver = order.historySync[lastKey].chauffeur
          if (driver === this.driversFile) {
            this.driverName = this.driverName || order.historySync[lastKey].chauffeurName
            order.orderNumber = order['.key']
            order.deliveryOrder = order.historySync[lastKey].deliveryOrder
            order.deliveryType = order.historySync[lastKey].deliveryType
            order.dateDispatch = order.historySync[lastKey].dateDispatch
            return true
          }
          return false
        })
        // this.sortOrdersForDriver()
      },

      sortOrdersForDriver () {
        this.processing.sort((a, b) => {
          // Sort by dispatchDate first and then by deliveryOrder
          const aDispatchDate = (a.dateDispatch) ? new Date(a.dateDispatch).getTime() : Infinity
          const bDispatchDate = (b.dateDispatch) ? new Date(b.dateDispatch).getTime() : Infinity
          if (aDispatchDate < bDispatchDate) {
            return -1
          } else if (aDispatchDate > bDispatchDate) {
            return 1
          } else {
            return (b.deliveryOrder || Infinity) - (a.deliveryOrder || Infinity)
          }
        })
      },

      validateLateOrders () {
        this.lateOrdersPresent = false
        const orders = this.processing.map(order => ({ ...order }))
        orders.forEach((order) => {
          order.isLate = false
          order.isPartialLate = false
          order.isWarning = false

          if (this.isLateOrder(order)) {
            order.isLate = true
            this.lateOrdersPresent = true
          } else if (this.isWarningOrder(order)) {
            order.isWarning = true
          }
        })
        if (!this.lateOrdersPresent && !orders.some(order => order.isWarning)) {
          this.disableDefaultSort = false
        }
        this.processing = orders
      },

      disableActions (order) {
        return this.lateOrdersPresent && !order.isLate
      },

      filterZones (pickZones, dropZones) {
        this.showFilterZonesModal = false
        this.filteredPickZones = pickZones
        this.filteredDropZones = dropZones

        let pickZonesLength = pickZones.length
        let dropZonesLength = dropZones.length

        if (!pickZonesLength && !dropZonesLength) {
          this.processing = this.originalProcessing
          return
        }
        this.processing = this.originalProcessing.filter(ord => {
           return (!pickZonesLength || pickZones.includes(ord.transmitterZoneId)) &&
                    (!dropZonesLength || dropZones.includes(ord.receiverZoneId))
        })
      },

      clearZonesFilter () {
        this.filteredPickZones = []
        this.filteredDropZones = []
      },

      isWarningOrder (order) {
        const statuses = [ 'Processing', 'Reject', 'Attente', 'Transit' ]

        if (!order.warningTime) return false

        const currentDate = Date.now()

        return (statuses.includes(order.status) && currentDate >= order.warningTime)
      },

      isLateOrder (order) {
        const statuses = [ 'Processing', 'Reject', 'Attente', 'Transit' ]

        if (!order.status) return false

        if (!order.lateTime) return false

        const currentDate = Date.now()

        return (statuses.includes(order.status) && currentDate >= order.lateTime)
      },

      openLateTimeExtentionModal () {
        this.fetchSelected('DISPATCH')
        this.lateTimeExtension = true
      },

      async getZones () {
        // Use zones from store
        if (!this.$store.state.zonesLoaded) {
          await this.$store.dispatch('subscribeToZones')
        }
        const storeZones = this.$store.state.zones
        if (!storeZones.length) return

        this.zones = storeZones.map(zone => ({
          value: zone.id,
          text: zone.zoneName
        }))

        this.pickZones = this.zones.filter(zone => !this.passedPickZones || this.passedPickZones.includes(zone.value))
        this.dropZones = this.zones.filter(zone => !this.passedDropZones || this.passedDropZones.includes(zone.value))
      },

      clearSelected () {
        this.selected.splice(0, this.selected.length)
        this.$forceUpdate()
      },

      handleCheckboxChange (checked, value) {
        if (checked && !this.selected.includes(value)) {
          this.selected.push(value)
        } else if (!checked) {
          this.selected = this.selected.filter((id) => id !== value)
        }
        this.$forceUpdate()
      },

      updateSelectedOrders (selected) {
        this.selected = selected
      },

      shortenString (text) {
        if (typeof text === 'undefined') return text
        else {
          let subString = text.substring(0, 22)
          if (text.length > 22) subString += '...'
          return subString
        }
      },

      updateFilterResults (sortResults) {
        this.filterResults = sortResults
        this.addMarkerWithArray()
      },

      /** Updates the location of an order in the @selectedFull array after the user changes and saves the location in DeliveryLocationModal */
      updateOrderLocation (updatedOrder) {
        this.selectedFull.find((originalOrder, index) => {
          if (originalOrder.orderNumber === updatedOrder.orderNumber) {
            this.selectedFull[index] = updatedOrder
          }
        })
      },

      /** Updates the order in @selectedFull so the button in ShortDispatch gets updated for UX purposes */
      updateOrderInSelectedFull (orderId, historyKey, updatedOrder) {
        this.selectedFull.find((originalOrder, index) => {
          if (originalOrder.orderNumber === orderId) {
            this.selectedFull[index].historySync[historyKey] = updatedOrder
          }
        })
      },

      /** Used to set the red (false) or green (true) buttons in Short Dispatch */
      checkHistory (history) {
        const isTruthy = this.$refs.distModal.checkHistory(history)
        return isTruthy
      },

      // Button: Optimize Route
      // Open directions modal and set order info
      async setOrderInfo () {
        this.modal.directions = true
        this.selectedFull = []

        for (let i = 0; i < this.selected.length; i++) { // Load 'this.selectedFull' with all the information of its order
          await db.ref('database').child('transporter').child(this.companyUID).child('deliveries').child(this.selected[i]).once('value').then(snap => {
            this.selectedFull.push(snap.val())
          })
        }
      },

      // Button: Create map
      // Create a map with determineDirections()
      createMapPath (startLocation, endLocation) {
        startLocation = this.formatString(startLocation, 'SEMI')
        endLocation = this.formatString(endLocation, 'SEMI')

        this.determineDirections(startLocation, endLocation)
      },

      // Function: createMapPath()
      // Send the path information to the Google API and render a map with its results
      /** @link https://developers.google.com/maps/documentation/directions/get-directions */

      async determineDirections (startLocation, endLocation) {
        let directionsService = new this.google.maps.DirectionsService()
        let directionsRenderer = new this.google.maps.DirectionsRenderer()

        let map = new this.google.maps.Map(document.getElementById('directionMap'))
        directionsRenderer.setMap(map)

        directionsService.route({
          origin: startLocation,
          destination: endLocation,
          travelMode: 'DRIVING',
          // transitMode: ,
          drivingOptions: {
            departureTime: new Date(),
            trafficModel: 'bestguess'
          },
          unitSystem: this.google.maps.UnitSystem.METRIC,
          waypoints: this.mapWaypoints,
          optimizeWaypoints: true,
          provideRouteAlternatives: false,
          avoidFerries: this.isFerries,
          avoidHighways: this.isHighways,
          avoidTolls: this.isTolls
          // region: 'CA, US'
          }, (result, status) => {
            if (status === 'OK') {
              directionsRenderer.setDirections(result)
              this.setWaypointArray(result)
              this.setPathInfo(result)
            }
        })
      },

      // Function: determineDirections()
      // Fetches Ordered Array (Optimized) from Google results and re-orders 2nd array to create map URL.
      setWaypointArray (googleResult) {
        const grRef = googleResult.routes[0].waypoint_order
        let orderedArray = []

        for (let j = 0; j < grRef.length; j++) {
          orderedArray.push(this.mapWaypoints[grRef[j]])
        }

        this.createMapUrl(orderedArray)
      },

      // Function: setWaypointArray()
      // Create mapUrl with the given locations from an array
      createMapUrl (array) {
        let formattedWPoint = ''
        let destinationStart = ''
        let destinationEnd = ''

        for (let i = 0; i < array.length; i++) {
          formattedWPoint = formattedWPoint + array[i].location
          formattedWPoint = this.formatString(formattedWPoint, 'FULL')
          formattedWPoint = formattedWPoint + '/'
        }

        destinationStart = this.formatString(this.mapDestinationStart, 'FULL')
        destinationEnd = this.formatString(this.mapDestinationEnd, 'FULL')
        this.mapUrl = `https://www.google.com/maps/dir/` + destinationStart + `/` + formattedWPoint + destinationEnd
      },

      // Function: determineDirections()
      // Set the duration and distance information of a path from Google results.
      setPathInfo (googleResult) {
        const resRef = googleResult.routes[0].legs
        let pathDuration = 0
        let pathDistance = 0

        for (let i = 0; i < resRef.length; i++) {
          pathDistance += resRef[i].distance.value
          pathDuration += resRef[i].duration.value
        }

        this.formatPathInfo(pathDistance, pathDuration)
      },

      // Function: setPathInfo()
      // Format the duration and distance information of a path.
      formatPathInfo (pathDistance, pathDuration) {
        this.formattedDistance = pathDistance /= 1000
        this.formattedDistance = Math.round(pathDistance)

        this.formattedDurationH = Math.floor((pathDuration / 60 / 60))
        this.formattedDurationM = Math.round(((pathDuration / 60) % 60))
      },

      // Input-Field: Vue Google Autocomplete
      // Because the VGA is kind of weird we have to receive the data first and then make it dance
      updateMapLocationVGA (placeResultData, formattedAddress) {
        this.updateMapLocation(formattedAddress, 'VUE-AUTOCOMPLETE')
      },

      // Button, Input-Field: PICKUP/CURR/DROP, My Address button || Datalist, updateMapLocationVGA Input-Field
      // Update location of mapDestinationStart, mapWaypoint or mapDestinationEnd point of Google map
      updateMapLocation (locationInfo, locField) {
        // False = Start, Null = Waypoint, True = End
        switch (this.mapDestinationToggle) {
          case false:
            this.switchCaseDestinationStart(locationInfo, locField)
            this.switchDestinationField()
            break
          case null:
            this.switchCaseDestinationWaypoint(locationInfo, locField)
            break
           case true:
            this.switchCaseDestinationEnd(locationInfo, locField)
            this.switchDestinationField()
            break
          default:
            console.log('Error in updateMapLocation')
          }

        this.mapDestinationStart = this.formatString(this.mapDestinationStart, 'SEMI')
        this.mapDestinationEnd = this.formatString(this.mapDestinationEnd, 'SEMI')
      },

      // Function: updateMapLocation
      // Set the Start destination with the appropriate location
      switchCaseDestinationStart (locationInfo, locField) {
        switch (locField) {
          case 'PICKUP':
            let transmitterLocation = locationInfo.transmitterAddress + ', ' + locationInfo.transmitterCity + ', ' + locationInfo.transmitterCountry + ', ' + locationInfo.transmitterPostcode + ', ' + locationInfo.transmitterProvince
            this.mapDestinationStart = transmitterLocation
            break
          case 'CURRENT':
            let currentLocation = locationInfo.latitude + ', ' + locationInfo.longitude
            this.mapDestinationStart = currentLocation
            break
          case 'DROP':
            let receiverLocation = locationInfo.receiverAddress + ', ' + locationInfo.receiverCity + ', ' + locationInfo.receiverCountry + ', ' + locationInfo.receiverPostcode + ', ' + locationInfo.receiverProvince
            this.mapDestinationStart = receiverLocation
            break
          case 'USER':
            let userLocation = this.userInfo.address + ', ' + this.userInfo.city + ', ' + this.userInfo.postcode + ', ' + this.userInfo.province
            this.mapDestinationStart = userLocation
            break
          case 'DATALIST':
            let datalistLocation = locationInfo.address + ', ' + locationInfo.city + ', ' + locationInfo.country + ', ' + locationInfo.postcode + ', ' + locationInfo.province
            this.mapDestinationStart = datalistLocation
            break
          case 'VUE-AUTOCOMPLETE':
            let autocompleteLocation = locationInfo.formatted_address
            this.mapDestinationStart = autocompleteLocation
            break
          default:
            this.mapDestinationStart = this.$t('Zone.notFound')
            console.log('Error in SwitchCaseOrigin')
        }
      },

      // Function: updateMapLocation
      // Set the Waypoint destination with the appropriate location
      switchCaseDestinationWaypoint (locationInfo, locField) {
        let waypoint = {}

        switch (locField) {
          case 'PICKUP':
            waypoint = {
              location: locationInfo.transmitterAddress + ', ' + locationInfo.transmitterCity + ', ' + locationInfo.transmitterCountry + ', ' + locationInfo.transmitterPostcode + ', ' + locationInfo.transmitterProvince,
              stopover: true
            }
            this.pushWaypoints(waypoint)
            break
          case 'CURRENT':
            waypoint = {
              location: locationInfo.latitude + ', ' + locationInfo.longitude,
              stopover: true
            }
            this.pushWaypoints(waypoint)
            break
          case 'DROP':
            waypoint = {
              location: locationInfo.receiverAddress + ', ' + locationInfo.receiverCity + ', ' + locationInfo.receiverCountry + ', ' + locationInfo.receiverPostcode + ', ' + locationInfo.receiverProvince,
              stopover: true
            }
            this.pushWaypoints(waypoint)
            break
          case 'USER':
            waypoint = {
              location: this.userInfo.address + ', ' + this.userInfo.city + ', ' + this.userInfo.postcode + ', ' + this.userInfo.province,
              stopover: true
            }
            this.pushWaypoints(waypoint)
            break
          case 'DATALIST':
            waypoint = {
              location: locationInfo.address + ', ' + locationInfo.city + ', ' + locationInfo.country + ', ' + locationInfo.postcode + ', ' + locationInfo.province,
              stopover: true
            }
            this.pushWaypoints(waypoint)
            break
          case 'VUE-AUTOCOMPLETE':
            waypoint = {
              location: locationInfo.formatted_address,
              stopover: true
            }
            this.pushWaypoints(waypoint)
            break
          default:
            waypoint = {
              location: '',
              stopover: false
            }
            this.pushWaypoints(waypoint)
            console.log('Error in SwitchCaseWaypoint')
        }
      },

      // Function: switchCaseDestinationWaypoint()
      // Add waypoint into mapWaypoints array
      pushWaypoints (waypointLocation) {
        this.mapWaypoints.push(waypointLocation)
      },

      // Function: updateMapLocation
      // Set the End destination with the appropriate location
      switchCaseDestinationEnd (locationInfo, locField) {
        switch (locField) {
          case 'PICKUP':
            let transmitterLocation = locationInfo.transmitterAddress + ', ' + locationInfo.transmitterCity + ', ' + locationInfo.transmitterCountry + ', ' + locationInfo.transmitterPostcode + ', ' + locationInfo.transmitterProvince
            this.mapDestinationEnd = transmitterLocation
            break
          case 'CURRENT':
            let currentLocation = locationInfo.latitude + ', ' + locationInfo.longitude
            this.mapDestinationEnd = currentLocation
            break
          case 'DROP':
            let receiverLocation = locationInfo.receiverAddress + ', ' + locationInfo.receiverCity + ', ' + locationInfo.receiverCountry + ', ' + locationInfo.receiverPostcode + ', ' + locationInfo.receiverProvince
            this.mapDestinationEnd = receiverLocation
            break
          case 'USER':
            let userLocation = this.userInfo.address + ', ' + this.userInfo.city + ', ' + this.userInfo.postcode + ', ' + this.userInfo.province
            this.mapDestinationEnd = userLocation
            break
          case 'DATALIST':
            let datalistLocation = locationInfo.address + ', ' + locationInfo.city + ', ' + locationInfo.country + ', ' + locationInfo.postcode + ', ' + locationInfo.province
            this.mapDestinationEnd = datalistLocation
            break
          case 'VUE-AUTOCOMPLETE':
            let autocompleteLocation = locationInfo.formatted_address
            this.mapDestinationEnd = autocompleteLocation
            break
          default:
            this.mapDestinationEnd = this.$t('Zone.notFound')
            console.log('Error in SwitchCaseDestination')
        }
      },

      // Function: Bunch of functions
      // Format strings to be properly used/displayed
      formatString (string, formatSize) {
        let formattedString = string

        formattedString = formattedString.replace(/undefined/g, '')
        formattedString = formattedString.replace(', , ', ', ')
        formattedString = formattedString.replace(' ,', ', ')
        formattedString = formattedString.replace(/\\u0027/g, `'`)

        if (formatSize === 'FULL') {
          formattedString = formattedString.replace(/ /g, '+')
          formattedString = formattedString.replace(/\++/g, '+')
          formattedString = formattedString.replace(/#/g, '')
        }

        return formattedString
      },

      // Buttons: Ferries, Highways, Tolls
      // Toggle wether or not to use Ferries, Highways, Tolls
      setGoogleRequestParameters (field) {
        switch (field) {
          case 'SHIP':
            this.isFerries = !this.isFerries
            break
          case 'HIGHWAY':
            this.isHighways = !this.isHighways
            break
          case 'TOLL':
            this.isTolls = !this.isTolls
            break
          default:
            console.log('You got an error somehow: setGoogleRequestParameters()')
        }
      },

      // Button: Confirm path
      // 8=====> ~~~ ( . Y . ) :^)
      // Push map URL into list
      pushMapUrl () {
        this.mapUrlList.push({
          mapUrl: this.mapUrl,
          mapStart: this.mapDestinationStart,
          mapEnd: this.mapDestinationEnd
          })
        this.mapUrl = ''
        this.mapDestinationStart = this.mapDestinationEnd
        this.mapWaypoints = []
        this.mapDestinationEnd = ''
        this.mapDestinationToggle = true
      },

      // Button: X
      // Remove URL from list of map URLS
      deleteMapUrl (index) {
        this.mapUrlList.splice(index, 1)
      },

      // Button: Send to drivers
      // Send map URLS to drivers
      sendMapUrl () {
        db.ref('database').child('transporter').child(this.companyUID).child('user').child('employees').child(this.mapUrlDriverUid).child('infos').child('email').once('value').then(snap => {
          let driverEmail = snap.val()

          dbMapUrl.ref('email-request').push().set({
            dateCreated: this.formatDate(new Date()),
            company: this.companyUID,
            driverEmail: driverEmail,
            mapList: this.mapUrlList
            }
          )
        })

        this.clearSelected()
      },

      // Button, Input-Field: Set [Start, Waypoints, End] buttons, [Pickup, Curr, Drop] buttons, VueAutocomplete input, Datalist input
      // Select which map destination to set
      switchDestinationField (destination) {
        switch (destination) {
          case false:
            this.mapDestinationToggle = false
            break
          case true:
            this.mapDestinationToggle = true
            break
          case null:
            this.mapDestinationToggle = null
            break
          default:
            this.mapDestinationToggle = !this.mapDestinationToggle
        }
      },

      // Button: Reset waypoint (Icon)
      // Reset all waypoints
      resetWaypoints () {
        this.mapWaypoints = []
      },

      openShortDispatch () {
        this.fetchSelected('DISPATCH')
        this.loadAddressBook()

        this.isShortDispatchModal = true
      },

      openDeliveryOrder () {
        const deliveryOrderStatuses = [ 'Pick', 'Dispatch', 'Attente', 'Inspection' ]
        this.driversDispatchOrders = this.processing.filter(order => deliveryOrderStatuses.includes(order.status))
        this.isDeliveryOrderModal = true
      },

      deleteCustomView () {
        db.ref('database/transporter/' + this.companyUID + '/customViewsZone').child(this.selectedCustomView).set(null).then(() => {
          this.modal.deleteCustomView = false
          this.selectedCustomView = ''
        }).catch((error) => {
          console.log(error)
        })
      },

      toggleInfoWindow (marker, idx) {
        this.infoWindowPos = marker.posOrigin
        this.infoWindowPos2 = marker.posDestination2
        this.infoWindowPos3 = marker.posCurrent3
        this.infoContent = this.getInfoWindowContent(marker)
        if (this.currentMidx === idx) {
          this.infoWinOpen = !this.infoWinOpen
        } else {
          this.infoWinOpen = true
          this.currentMidx = idx
        }
      },

      getInfoWindowContent (marker) {
        return (
          `<div class="">
          <div>
            <div>
              <div class="m-2"><span style="font-weight: bold;">Origine: </span>
                ${this.$realName(marker.fullOrder, 'transmitter')}
              </div>
            </div>
            <div class="m-2"><span style="font-weight: bold;">Destination:  </span>
              ${this.$realName(marker.fullOrder, 'receiver')}
              <br>
            </div>
            <div class="m-2"><span style="font-weight: bold;">Status:  </span>
              ${marker.fullOrder.status}
              <br>
            </div>
            <a class="" target="_blank" href="#/OrderInfo?orderId=${marker.fullOrder['.key']}">
            ${marker.fullOrder['.key']}
          </a>
          </div>
        </div>`)
      },

      openStatusEdit () {
        this.fetchSelected('DISPATCH')
        this.isStatusEdit = true
      },

      openInfoWindowTemplate (item) {
        // this.setInfoWindowTemplate(item)
        this.infoWindow.posOrigin = this.getCoordinates(item)
        this.infoWindow.open = true
      },

      openWindow (item) {
        this.markers.map(marker => {
          this.$set(item, 'open', true)
          return item
        })
      },

      async addMarkerWithArray () {
        this.isLoading = true
        this.markers = []

        await this.setMarkerLocations()

        await this.filterOrders()

        this.isLoading = false
      },

      async setMarkerLocations () {
        this.isLegend = false
        await this.filterResults.forEach((o) => {
          if (this.verifyLatLong(o)) {
              o.latitude = !o.latitude || o.latitude === 0.001 ? o.transmitterLat || 0.001 : o.latitude
              o.longitude = !o.longitude || o.longitude === 0.001 ? o.transmitterLong || 0.001 : o.longitude

              o.receiverLat = o.receiverLat || 0.001
              o.receiverLong = o.receiverLong || 0.001

              var transLat = this.offsetMapMarkerValue(o.transmitterLat)
              var transLong = this.offsetMapMarkerValue(o.transmitterLong)

              var receivLat = this.offsetMapMarkerValue(o.receiverLat)
              var receivLong = this.offsetMapMarkerValue(o.receiverLong)

              var lat = this.offsetMapMarkerValue(o.latitude)
              var long = this.offsetMapMarkerValue(o.longitude)
            // Set lat and lng for marker positions for all 3 maps
            const marker = {
              lat: parseFloat(transLat),
              lng: parseFloat(transLong)
            }

            const marker2 = {
              lat: parseFloat(receivLat),
              lng: parseFloat(receivLong)
            }

            const marker3 = {
              lat: parseFloat(lat),
              lng: parseFloat(long)
            }

            // Push Object into array containing all info of an order and position in each map
            this.markers.push({
              fullOrder: o,
              posOrigin: marker,
              posDestination2: marker2,
              posCurrent3: marker3
            })

            // this.markers2.push({fullOrder: o, posOrigin: marker2, posDestination2: marker})
            this.places.push(this.currentPlace)
            this.places2.push(this.currentPlace2)
            this.places3.push(this.currentPlace3)
            this.center = marker
            this.currentPlace = null
            this.resetCarCount()
          }
        })
        this.isLegend = true
      },

      // Filter Order dates to appropriate car icon
      async filterOrders () {
        await this.markers.forEach((element) => {
          if (element.fullOrder.isLate || element.fullOrder.isPartialLate) {
            element.fullOrder['icon'] = this.redCar
            this.redCarCount++
          } else if (element.fullOrder.isWarning) {
            element.fullOrder['icon'] = this.orangeCar
            this.orangeCarCount++
          } else {
            element.fullOrder['icon'] = this.greenCar
            this.greenCarCount++
          }
        })
      },

      resetCarCount () {
        this.greenCarCount = 0
        this.orangeCarCount = 0
        this.redCarCount = 0
        this.defaultCarCount = 0
      },

      /** Verifies an order has a value for each data
       * @param order: The order LUL
      */
      verifyLatLong (order) {
        if (order.transmitterLong !== null &&
            order.transmitterLat !== null &&
            order.receiverLong !== null &&
            order.receiverLat !== null &&
            order.latitude !== null &&
            order.longitude !== null &&
            typeof order.longitude !== 'undefined' &&
            typeof order.latitude !== 'undefined') {
          return true
        } else return false
      },

      /** Offsets a lat/long value by a random number to avoid overlapping markers on Google Maps
       * @param coordinate: Float value of a lat/long position on Google Maps
       */
      offsetMapMarkerValue (coordinate) {
        let min = 0.999999
        let max = 1.000001

        return coordinate * (Math.random() * (max - min) + min)
      },

      daysBetweenNow (date1) {
        var oneDay = 24 * 60 * 60 * 1000
        var firstDate = new Date(date1)
        var secondDate = new Date()
        var diffDays2 = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)))
        return diffDays2
      },

      calcBusinessDays (dateValue) {
        // This makes no effort to account for holidays
        // Counts end day, does not count start day
        // make copies we can normalize without changing passed in objects
        var start = new Date(dateValue)
        var end = new Date()

        // initial total
        var totalBusinessDays = 0

        // normalize both start and end to beginning of the day
        start.setHours(0, 0, 0, 0)
        end.setHours(0, 0, 0, 0)

        var current = new Date(start)
        current.setDate(current.formatDate() + 1)

        // loop through each day, checking
        var day

        while (current <= end) {
          day = current.getDay()
          if (day >= 1 && day <= 5) {
            ++totalBusinessDays
          }
          current.setDate(current.formatDate() + 1)
        }
        return totalBusinessDays
      },

      calcBusinessDays2 (dateValue) {
        // This makes no effort to account for holidays
        // Counts end day, does not count start day
        // make copies we can normalize without changing passed in objects
        var start = new Date()
        var end = new Date(dateValue)

        // initial total
        var totalBusinessDays = 0

        // normalize both start and end to beginning of the day
        start.setHours(0, 0, 0, 0)
        end.setHours(0, 0, 0, 0)

        var current = new Date(start)
        current.setDate(current.formatDate() + 1)

        // loop through each day, checking
        var day
        while (current <= end) {
          day = current.getDay()
          if (day >= 1 && day <= 5) {
            ++totalBusinessDays
          }
          current.setDate(current.formatDate() + 1)
        }
        return totalBusinessDays
      },

      // YYYY-MM-DD + hh:mm:ss + AM/PM
      getDate: function (timestamp) {
        var date = new Date(timestamp)
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
      },

      // YYYY-MM-DD
      formatDate (date) {
        var formattedDate = new Date(date)
        return formattedDate.getFullYear() + '-' + ('0' + (formattedDate.getMonth() + 1)).slice(-2) + '-' + ('0' + formattedDate.getUTCDate()).slice(-2)
      },

      checkDate (date1) {
        var firstDate = new Date(date1)
        var secondDate = new Date()
        if (firstDate <= secondDate) {
          return true
        } else {
          return false
        }
      },

      addCustomView () {
        var nv = this.newCustomView
        var custom = {query: {name: nv.name, customView: true}}
        if (nv.VIN !== '') custom.query.vin = nv.VIN
        if (nv.referenceNumber !== '') custom.query.reference = nv.referenceNumber
        if (nv.source !== '') custom.query.source = nv.source
        if (nv.pickup !== '') custom.query.pickup = nv.pickup
        if (nv.delivery !== '') custom.query.delivery = nv.delivery
        if (nv.dateReceptionMin !== '') custom.query.from = Date.parse(nv.dateReceptionMin)
        if (nv.dateReceptionMax !== '') custom.query.to = Date.parse(nv.dateReceptionMax)
        if (nv.status !== '') custom.query.status = nv.status
        if (nv.billing !== '') custom.query.billing = nv.billing
        if (nv.driver !== '') custom.query.driver = nv.driver
        if (nv.afterXDays !== '') custom.query.after = parseInt(nv.afterXDays)
        if (nv.beforeXDays !== '') custom.query.before = parseInt(nv.beforeXDays)
        if (nv.provincePick !== '') custom.query.provincePick = nv.provincePick
        if (nv.provinceDrop !== '') custom.query.provinceDrop = nv.provinceDrop
        db.ref('database/transporter/' + this.companyUID + '/customViewsZone').push().set(custom).then(() => {
          this.modal.newCustomView = false
          this.clear()
        }).catch((error) => {
          console.log(error)
        })
      },

      goToCustomView (to) {
        this.$router.go(to)
      },

      applyBillingDateToAll (date) {
        this.selectedFull.forEach((element) => {
          element.billingDate = date
        })
      },

      clearfeedbackMessage () {
        this.feedbackMessage = ''
      },

      openVinPrinting () {
        this.fetchSelected()
        this.vinPrinting = true
      },

      fetchSelected (action) {
        this.selectedFull = []
        this.priceOrderLink = []

        this.selected.forEach((orderId) => {
          db.ref('database').child('transporter').child(this.companyUID).child('deliveries').child(orderId).once('value').then((snap) => {
            this.$set(this.selectedFull, this.selectedFull.length, snap.val())
            this.$set(this.selectedFull[this.selectedFull.length - 1], 'orderNumber', snap.key)

            if (action === 'DISPATCH' || (action === 'BILLING' && !snap.val().price)) {
              this.$set(this.selectedFull[this.selectedFull.length - 1], 'price', '')
              if (action === 'DISPATCH') {
                this.setPriceOrderLink(orderId, snap.val())
                this.$set(this.selectedFull[this.selectedFull.length - 1], 'comment', 'Client/Customer: ' + snap.val().payerName)
                if (this.userInfo.driverComment) this.selectedFull[this.selectedFull.length - 1].comment += '\n' + snap.val().comment
              }
            }
            if (!snap.val().taxes) this.$set(this.selectedFull[this.selectedFull.length - 1], 'taxes', '')
            if (!snap.val().taxesComment) this.$set(this.selectedFull[this.selectedFull.length - 1], 'taxesComment', '')
            if (!snap.val().transmitterCountry) this.$set(this.selectedFull[this.selectedFull.length - 1], 'transmitterCountry', '')
            if (!snap.val().receiverCountry) this.$set(this.selectedFull[this.selectedFull.length - 1], 'receiverCountry', '')
            if (!snap.val().billingDate) this.$set(this.selectedFull[this.selectedFull.length - 1], 'billingDate', this.formatDate(Date.now()))
            this.order = JSON.parse(JSON.stringify(this.selectedFull[0]))
          })
        })
      },

      async filterSearch (searchType, searchText) {
        await this.evaluateFiltering(searchType, searchText)
        await this.addMarkerWithArray()
        // TODO: Attempt to make search filter and remove filter call addMarkerWithArray at the same time
      },

      async filterRemove (searchType, searchText) {
        await this.removeSearchedItem(searchType, searchText)
        await this.addMarkerWithArray()
        // TODO: Attempt to make search filter and remove filter call addMarkerWithArray at the same time
      },

    setPriceOrderLink (orderId, orderInfo) {
      let priceObj = {
        orderId: orderId,
        price: orderInfo.price,
        orderInfo: orderInfo
      }

      this.priceOrderLink.push(priceObj)
    },

    evaluateFiltering (attr, val) {
      this.fields[attr] = val

      var isAttrDupe = false
      if (val === '') {
        return
      }
      this.searchHistory.find((o, i) => {
        if (o.searchType === attr) {
          var storedDupeTag = this.setSearchedItemTag(attr)
          this.searchHistory[i] = {
            searchType: attr, searchText: val, historyTypeTag: storedDupeTag}
          isAttrDupe = true
          return
        }
      })
      if (!isAttrDupe) {
        this.addSearchedItem(attr, val)
      }
    },

    addSearchedItem (searchedType, searchedText) {
      var storedTag = this.setSearchedItemTag(searchedType)
      this.searchHistory.push({searchType: searchedType, searchText: searchedText, historyTypeTag: storedTag})
    },

    setSearchedItemTag (attr) {
      // TODO: Refactor all IFs for a switch case
      var storedTag
      if (attr === '.key') { storedTag = this.$t('OrderCurrent.order') }
      if (attr === 'creationDate') { storedTag = this.$t('OrderCurrent.date') }
      if (attr === 'status') { storedTag = this.$t('OrderCurrent.status') }
      if (attr === 'driverName') { storedTag = this.$t('OrderCurrent.driver') }
      if (attr === 'numRef') { storedTag = this.$t('OrderCurrent.reference') }
      if (attr === 'source') { storedTag = this.$t('OrderCurrent.source') }
      if (attr === 'vin') { storedTag = this.$t('OrderCurrent.VIN') }
      if (attr === 'transmitterName') { storedTag = this.$t('OrderCurrent.pickup') }
      if (attr === 'receiverName') { storedTag = this.$t('OrderCurrent.delivery') }
      if (attr === 'payerName') { storedTag = this.$t('OrderCurrent.billing') }
      if (attr === 'deliveryOrder') { storedTag = 'deliveryOrder' }
      if (attr === 'transmitterZone') { storedTag = this.$t('OrderCurrent.transmitter_zone') }
      if (attr === 'receiverZone') { storedTag = this.$t('OrderCurrent.receiver_zone') }
      return storedTag
    },

    removeSearchedItem (index, attr) {
      this.searchHistory.splice(index, 1)
      this.evaluateFiltering(attr, '')
    },

    loadAddressBook () {
      console.log('initializing addressbook')
      db.ref('database/transporter/' + this.companyUID + '/addressbook').once('value').then((snap) => {
        let addressbookArray = []
        snap.forEach((element) => {
          let item = element.val()
          item.key = element.key
          addressbookArray.push(item)
        })
        this.addressbook = addressbookArray
      })
    },

      setAndSearch: function (event, section) {
        // TODO: Doesn't work on bruno@transportbmampr but works on cooldeamoncr@hotmail.com 🤔
        switch (section) {
          case 'mapUrlDriver':
            this.mapUrlDriver = event.value
            this.mapUrlDriverUid = event.key
            break
          case 'mapDirection':
            this.$refs.AutocompleteSearchMapDirection.clear()
            this.mapLocDatalist = event.value
            this.mapLocDatalistUid = event.key
            if (event.key !== null) {
              db.ref('users/dealersList/' + this.mapLocDatalistUid).once('value').then((snap) => {
                if (snap.val()) {
                  let locationInfo = {
                    address: snap.val().address,
                    country: snap.val().country,
                    city: snap.val().city,
                    postcode: snap.val().postcode,
                    province: snap.val().province
                  }
                  this.updateMapLocation(locationInfo, 'DATALIST')
                }
              }).catch(function (error) {
                console.log(error)
              })
              this.addressbook.forEach((entry) => {
                if (entry['key'] === this.datalist.pickupUid) {
                  this.order.transmitterName = entry.name
                  this.order.transmitterAddress = entry.address
                  this.order.transmitterCity = entry.city
                  this.order.transmitterPostcode = entry.postcode
                  this.order.transmitterPhone = entry.phone
                  this.order.transmitterEmail = entry.receptionEmail || ''
                  this.order.transmitterFax = entry.fax
                  this.order.transmitterProvince = entry.province
                  this.order.transmitterCountry = entry.country
                }
              })
            }
            break
          case 'pickup':
            this.$refs.AutocompleteSearchPickup.clear()
            this.datalist.pickup = event.value
            this.datalist.pickupUid = event.key
            if (event.key !== null) {
              db.ref('users/dealersList/' + this.datalist.pickupUid).once('value').then((snap) => {
                if (snap.val()) {
                  this.order.transmitterName = snap.val().name
                  this.order.transmitterAddress = snap.val().address
                  this.order.transmitterCity = snap.val().city
                  this.order.transmitterPostcode = snap.val().postcode
                  this.order.transmitterPhone = snap.val().phone
                  this.order.transmitterEmail = snap.val().receptionEmail || ''
                  this.order.transmitterFax = snap.val().fax
                  this.order.transmitterProvince = snap.val().province
                  this.order.transmitterCountry = snap.val().country
                }
              }).catch(function (error) {
                console.log(error)
              })
              this.addressbook.forEach((entry) => {
                if (entry['key'] === this.datalist.pickupUid) {
                  this.order.transmitterName = entry.name
                  this.order.transmitterAddress = entry.address
                  this.order.transmitterCity = entry.city
                  this.order.transmitterPostcode = entry.postcode
                  this.order.transmitterPhone = entry.phone
                  this.order.transmitterEmail = entry.receptionEmail || ''
                  this.order.transmitterFax = entry.fax
                  this.order.transmitterProvince = entry.province
                  this.order.transmitterCountry = entry.country
                }
              })
            }
            break
          case 'delivery':
            this.$refs.AutocompleteSearchDelivery.clear()
            this.datalist.delivery = event.value
            this.datalist.deliveryUid = event.key
            if (event.key !== null) {
              db.ref('users/dealersList/' + this.datalist.deliveryUid).once('value').then((snap) => {
                if (snap.val()) {
                  this.order.receiverName = snap.val().name
                  this.order.receiverAddress = snap.val().address
                  this.order.receiverCity = snap.val().city
                  this.order.receiverPostcode = snap.val().postcode
                  this.order.receiverPhone = snap.val().phone
                  this.order.receiverEmail = snap.val().receptionEmail || ''
                  this.order.receiverFax = snap.val().fax
                  this.order.receiverProvince = snap.val().province
                  this.order.receiverCountry = snap.val().country
                  if (this.billingSame) this.order.sageID = snap.val().sageID
                  this.backup.sageIDDelivery = snap.val().sageID
                  this.onInputBillingSame()
                }
              }).catch(function (error) {
                console.log(error)
              })
              this.addressbook.forEach((entry) => {
                if (entry['key'] === this.datalist.deliveryUid) {
                  this.order.receiverName = entry.name
                  this.order.receiverAddress = entry.address
                  this.order.receiverCity = entry.city
                  this.order.receiverPostcode = entry.postcode
                  this.order.receiverPhone = entry.phone
                  this.order.receiverEmail = entry.receptionEmail || ''
                  this.order.receiverFax = entry.fax
                  this.order.receiverProvince = entry.province
                  this.order.receiverCountry = entry.country
                  if (this.billingSame) this.order.sageID = entry.sageID
                  this.backup.sageIDDelivery = entry.sageID
                  this.onInputBillingSame()
                }
              })
            }
            break
          case 'billing':
            this.datalist.billing = event.value
            this.datalist.billingUid = event.key
            if (event.key !== null) {
              db.ref('users/dealersList/' + this.datalist.billingUid).once('value').then((snap) => {
                if (snap.val()) {
                  this.order.payerName = snap.val().name
                  this.order.payerAddress = snap.val().address
                  this.order.payerCity = snap.val().city
                  this.order.payerPostcode = snap.val().postcode
                  this.order.payerPhone = snap.val().phone
                  this.order.payerEmail = snap.val().receptionEmail || ''
                  this.order.payerFax = snap.val().fax
                  this.order.payerProvince = snap.val().province
                  this.order.payerCountry = snap.val().country
                  this.order.sageID = snap.val().sageID
                }
              }).catch(function (error) {
                console.log(error)
              })
              this.addressbook.forEach((entry) => {
                if (entry['key'] === this.datalist.billingUid) {
                  this.order.payerName = entry.name
                  this.order.payerAddress = entry.address
                  this.order.payerCity = entry.city
                  this.order.payerPostcode = entry.postcode
                  this.order.payerPhone = entry.phone
                  this.order.payerEmail = entry.receptionEmail || ''
                  this.order.payerFax = entry.fax
                  this.order.payerProvince = entry.province
                  this.order.payerCountry = entry.country
                  this.order.sageID = entry.sageID
                  console.log(entry)
                }
              })
            }
            break
          default:
          console.log('Section not found')
        }
      },

      // onInputBillingSame: function () {
      //   if (this.billingSame) {
      //     this.order.payerAddress = this.order.receiverAddress
      //     this.order.payerCity = this.order.receiverCity
      //     this.order.payerContact = this.order.receiverContact
      //     this.order.payerFax = this.order.receiverFax
      //     this.order.payerName = this.order.receiverName
      //     this.order.payerPhone = this.order.receiverPhone
      //     this.order.payerEmail = this.order.receiverEmail
      //     this.order.payerPostcode = this.order.receiverPostcode
      //     this.order.payerProvince = this.order.receiverProvince
      //     this.order.payerCountry = this.order.receiverCountry
      //   }
      // },

      clear: function () {
        for (let attr in this.order) {
          this.order[attr] = ''
        }
        this.dispatchOrder.chauffeurName = ''
        this.order.status = 'Processing'
        this.order.latitude = 0.001
        this.order.longitude = 0.001
        this.order.nbDispatch = 0
        for (let attr in this.datalist) {
          this.datalist[attr] = ''
        }
        this.vehicles = []
        this.VIN = ''
        this.MAKE = ''
        this.MODEL = ''
        this.YEAR = ''
        for (let attr in this.newCustomView) {
          this.newCustomView[attr] = ''
        }
        this.mapList = []
        this.mapDestinationStart = ''
        this.mapDestinationEnd = ''
        this.mapDestinationToggle = false
        this.mapWaypoints = []
        this.mapUrl = ''
        this.mapUrlList = []
        this.mapUrlDriver = ''
        this.formattedDurationH = 0
        this.formattedDurationM = 0
        this.formattedDistance = 0
      },

      addOrder: function () {
        var cigle = this.$store.state.userInfo.cigle
        var name = this.$store.state.userInfo.name
        this.order.transpCigle = cigle
        this.order.transpName = name
        this.addCustomer()
        for (var attr in this.order) {
          if (this.order[attr] === undefined) this.order[attr] = ''
        }
        this.vehicles.forEach((element) => {
          this.order.vin = element.vin
          this.order.make = element.make
          this.order.model = element.model
          this.order.year = element.year
          db.ref('test/transporter/' + this.companyUID + '/newDeliveries').push().set(this.order).then(() => {
            // ======================== ADD ORDER LOG =======================
            this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'ADD_ORDER', 'date': Date.now(), 'targetName': this.order.payerName})
            // ======================== ADD ORDER LOG =======================
          }).catch(function (error) {
            console.log(error)
          })
        })
        this.clear()
        this.closedModal = !this.closedModal
      },

      print: function (order) {
        if (!order.isPrinted) db.ref('database/transporter/' + this.companyUID + '/deliveries/' + order['.key']).update({'isPrinted': true})
      },

      addCustomer: function () {
        var order = this.order
        if (this.deliverySave) {
          var savedDelivery = {
            'address': order.receiverAddress,
            'city': order.receiverCity,
            'contact': order.receiverContact,
            'fax': order.receiverFax,
            'name': order.receiverName,
            // 'receptionEmail': order.receiverEmail,
            // 'emailList': [],
            'contacts': order.receiverContacts || [],
            'postcode': order.receiverPostcode,
            'country': order.receiverCountry,
            'province': order.receiverProvince,
            'phone': order.receiverPhone,
            'placeId': order.receiverPlaceId,
            'lat': order.receiverLat,
            'long': order.receiverLong,
            'zone': order.receiverZone,
            'zoneId': order.receiverZoneId
          }
          let receiverPlaceId = ''
          if (order.receiverPlaceId) {
            receiverPlaceId = order.receiverPlaceId
            let formattedName = this.removeInvalidChars(order.receiverName)

            db.ref('database/transporter/' + this.companyUID + '/addressbook')
            .child(receiverPlaceId + '-_name_-' + formattedName)
            .set(savedDelivery)
          } else db.ref('database/transporter/' + this.companyUID + '/addressbook').push().set(savedDelivery)
        }
        if (this.pickupSave) {
          var savedPickup = {
            'address': order.transmitterAddress,
            'city': order.transmitterCity,
            'contact': order.transmitterContact,
            'fax': order.transmitterFax,
            'name': order.transmitterName,
            // 'receptionEmail': order.transmitterEmail,
            // 'emailList': order.transmitterEmailList || [],
            'contacts': order.transmitterContacts || [],
            'postcode': order.transmitterPostcode,
            'country': order.transmitterCountry,
            'province': order.transmitterProvince,
            'phone': order.transmitterPhone,
            'placeId': order.transmitterPlaceId,
            'lat': order.transmitterLat,
            'long': order.transmitterLong,
            'zone': order.transmitterZone,
            'zoneId': order.transmitterZoneId
          }

          let transmitterPlaceId = ''

          if (order.transmitterPlaceId) {
            transmitterPlaceId = order.transmitterPlaceId
            let formattedName = this.removeInvalidChars(order.transmitterName)

            db.ref('database/transporter/' + this.companyUID + '/addressbook')
            .child(transmitterPlaceId + '-_name_-' + formattedName)
            .set(savedPickup)
          } else db.ref('database/transporter/' + this.companyUID + '/addressbook').push().set(savedPickup)
        }
      },

      removeInvalidChars (text) {
        text = text.replace('.', '')
        text = text.replace('$', '')
        text = text.replace('#', '')
        text = text.replace('[', '')
        text = text.replace(']', '')
        text = text.replace('/', '')
        return text
      },

      /** Gets the timestamp of when the vehicles are ready to sort them by time on the order table
       * Returns an @array with both values needed
      */
      getVehicleTimestamp (survey1, survey2) {
        let timestamp1 = this.setVehicleTimestamp(survey1)
        let timestamp2 = this.setVehicleTimestamp(survey2)

        let arrWithValuesToCompare = []
        arrWithValuesToCompare.push(timestamp1, timestamp2)

        return arrWithValuesToCompare
      },

      /** Sets that sheeet, if question IDs are changed in KNEQuick, make sure to change it here too D: */
      setVehicleTimestamp (survey) {
        let questionArr = survey[Object.keys(survey)]
        let timestamp = 0

        if (questionArr) {
          let question1P1 = questionArr.find(question => question.id === '1.1')

          if (typeof question1P1 !== 'undefined') {
            timestamp = this.getTimestamp(question1P1.answer)
          } else timestamp = 1
        }

        return timestamp
      },

      getOrderHistoryLength (order) {
        const orderObj = order
        let counter = 0

        for (const key in orderObj.historySync) {
          if (Object.hasOwnProperty.call(orderObj.historySync, key)) {
            counter++
          }
        }
        return counter.toString()
      },

      getDispatchHistoryPrice (historyEntry) {
        if (!historyEntry || typeof historyEntry !== 'object') return 0
        if (historyEntry.price !== undefined && historyEntry.price !== null && historyEntry.price !== '') return Number(historyEntry.price) || 0
        if (historyEntry.prix !== undefined && historyEntry.prix !== null && historyEntry.prix !== '') return Number(historyEntry.prix) || 0
        return 0
      },

      dispatchHistToolTip (order) {
        let text = this.$t('OrderCurrent.dispatch_history_tooltip')

        let orderInfoText = ''
        if (order.historySync) {
          for (const key in order.historySync) {
            if (Object.hasOwnProperty.call(order.historySync, key)) {
              orderInfoText += `${order.historySync[key].transmitterName}, ${order.historySync[key].transmitterCity}, ${order.historySync[key].transmitterProvince} -> ${order.historySync[key].receiverName}, ${order.historySync[key].receiverCity}, ${order.historySync[key].receiverProvince}, ${this.getDispatchHistoryPrice(order.historySync[key])}$<br>`
            }
          }
          text = `<strong> ${text} </strong> <br> ${orderInfoText}`
          return text
        }
        return ''
      },

      getOrderNotes (order) {
        let text = this.$t('OrderCurrent.notes')
        const notes = order.notes
        if (notes) {
          for (const key in notes) {
            if (Object.hasOwnProperty.call(notes, key)) {
              const element = notes[key]
              text += `<br>${element.text}`
            }
          }
        }
        return text
      },

      getOrderSurvey (orderSurvey) {
        let text = this.$t('Survey.text') + '<br>'

        if (orderSurvey) {
          for (const key in orderSurvey) {
            if (Object.hasOwnProperty.call(orderSurvey, key)) {
              const element = orderSurvey[key]
              element.forEach(question => {
                text += `<br> ${this.$t(`Survey.question_${question.id}`)} ${this.translateSurveyAnswer(question.answer)} <br>`
              })
            }
          }
        }

        return text
      },

      translateSurveyAnswer (answer) {
        if (answer === true) return this.$t('General.yes')
        else if (answer === false) return this.$t('General.no')
        else return answer
      },

      onResize: window._.debounce(function () {
        this.isScreenSmall = window.innerWidth < 800
      }, 50),

      getSurveyIconColor (survey) {
        let color = ''

        if (survey) {
          for (const key in survey) {
            if (Object.hasOwnProperty.call(survey, key)) {
              survey[key].forEach(question => {
                if (question.id === '1') color = 'rgb(3, 115, 3)'
                if (question.id === '1.1') {
                  let time = this.getTimestamp(question.answer)
                  if (time > Date.now()) color = 'red'
                  else if (time < Date.now()) color = 'rgb(3, 115, 3)'
                }
              })
            }
          }
        }

        return color
      },

      getTimestamp (receivedDate) {
        let timestamp = Date.parse(receivedDate)
        return timestamp
      }
    },

    mounted () {
      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })

      db.ref('users/transporters').child(this.companyUID).once('value').then((snapshot) => {
        this.$store.commit('setUserInfo', snapshot.val() || false)
        this.user = snapshot.val()
      })
    },

    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
      // Remove current maps listeners
      if (this.currentPolygonCompleteListener) {
        this.google.maps.event.removeListener(this.currentPolygonCompleteListener)
      }
      if (this.currentPathSetAtListener) {
        this.google.maps.event.removeListener(this.currentPathSetAtListener)
      }
      if (this.currentPathInsertAtListener) {
        this.google.maps.event.removeListener(this.currentPathInsertAtListener)
      }
      if (this.currentPathRemoveAtListener) {
        this.google.maps.event.removeListener(this.currentPathRemoveAtListener)
      }
      // Remove destination maps listeners
      if (this.destinationPolygonCompleteListener) {
        this.google.maps.event.removeListener(this.destinationPolygonCompleteListener)
      }
      if (this.destinationPathSetAtListener) {
        this.google.maps.event.removeListener(this.destinationPathSetAtListener)
      }
      if (this.destinationPathInsertAtListener) {
        this.google.maps.event.removeListener(this.destinationPathInsertAtListener)
      }
      if (this.destinationPathRemoveAtListener) {
        this.google.maps.event.removeListener(this.destinationPathRemoveAtListener)
      }
    },

    computed: {
      computed_newCount (newCount) {
        return newCount
      },
      checkWallFileZonePage () {
        return !!this.wallFile
      },
      wallFile () {
        return this.$route.params.wallFile
      },
      wallFileName () {
        return this.$route.params.wallFileName
      },
      wallFileOrders () {
        return this.$route.params.orders
      },
      driversFile () {
        return this.$route.params.drivers
      },
      driverStatus () {
        return this.$route.params.driverStatus
      },
      clientsFile () {
        return this.$route.params.client
      },
      passedPickZones () {
        return this.$route.params.pickZones
      },
      passedDropZones () {
        return this.$route.params.dropZones
      },
      google: gmapApi,

      filterResultsWithOrder () {
        let newArray = []
        this.filterResults.forEach((element) => {
          let newEle = element
          newEle.order = element['.key']
          newArray.push(element)
        })
        return newArray
      },

      // formCompleted: function () {
      //   var order = this.order
      //   return (
      //     this.vehicles.length !== 0 &&
      //     order.receiverName !== '' &&
      //     order.receiverAddress !== '' &&
      //     order.receiverCountry !== '' &&
      //     order.receiverCity !== '' &&
      //     order.receiverPostcode !== '' &&
      //     order.receiverProvince !== '' &&
      //     order.payerName !== '' &&
      //     order.payerAddress !== '' &&
      //     order.payerCountry !== '' &&
      //     order.payerCity !== '' &&
      //     order.payerPostcode !== '' &&
      //     order.payerProvince !== '' &&
      //     order.transmitterName !== '' &&
      //     order.transmitterAddress !== '' &&
      //     order.transmitterCountry !== '' &&
      //     order.transmitterCity !== '' &&
      //     order.transmitterPostcode !== '' &&
      //     order.transmitterProvince !== '' &&
      //     ((this.isSageOne && order.price !== '') || !this.isSageOne))
      // },

      // sageOneCheck () {
      //   return ((this.$store.state.userInfo.isSageOne && this.order.sageID !== '' && this.order.sageID !== undefined) || !this.$store.state.userInfo.isSageOne)
      // },

      allOrderID () {
        var orderIDs = ''
        this.selected.forEach((element, index) => {
          index !== 0 ? orderIDs += '+' + element : orderIDs += element
        })
        return orderIDs
      },

      allBillingFieldCompleted () {
        var result = true
        this.selectedFull.forEach((element) => {
          if (element.taxes === '' || element.price === '' || element.taxes === undefined || element.price === undefined || element.sageID === '' || element.sageID === undefined) result = false
        })
        return result
      },

      dispatchFormFilled () {
        return this.dispatchOrder.chauffeur !== '' &&
          this.order.transmitterName !== '' &&
          this.order.transmitterAddress !== '' &&
          this.order.transmitterCountry !== '' &&
          this.order.transmitterCity !== '' &&
          this.order.transmitterPostcode !== '' &&
          this.order.transmitterProvince !== '' &&
          this.order.receiverName !== '' &&
          this.order.receiverAddress !== '' &&
          this.order.receiverCountry !== '' &&
          this.order.receiverCity !== '' &&
          this.order.receiverPostcode !== '' &&
          this.order.receiverProvince !== ''
      },

      companyUID () {
        return this.$store.state.authorization.company
      },

      uid () {
        return this.$store.state.user.uid
      },

      // sageIDonly () {
      //   return this.addressbook.filter(customer => customer.sageID)
      // },

      isSageOne () {
        return this.$store.state.userInfo.isSageOne
      },

      userInfo () {
        return this.$store.state.userInfo
      },

      hasIntegration () {
        return this.$store.state.userInfo.hasIntegration
      },

      hasProvince () {
        return this.addressbook.filter(customer => customer.province && customer.city && customer.country)
      },

      isDateRoute () {
        return this.$route.query.newDate
      },

      newCount () {
        let count = {processing: 0, dispatch: 0, pick: 0, transit: 0, drop: 0, transfer: 0, reject: 0, waiting: 0, newNote: 0, newDate: 0}
        this.processing.forEach((o) => {
          if (o.read === false) count.newNote++
        })
        this.processing.forEach((o) => {
          if (o.datePromis !== null && o.datePromis !== '' && o.datePromis !== undefined) {
            var fdate = new Date(o.datePromis)
            var today = new Date()
            today.setHours(0, 0, 0, 0)
            if (fdate <= today) {
              count.newDate++
            }
          }
        })
        this.filterResults.forEach((o) => {
          if (o.status === 'Processing') count.processing++
          if (o.status === 'Dispatch') count.dispatch++
          if (o.status === 'Pick') count.pick++
          if (o.status === 'Transit') count.transit++
          if (o.status === 'Drop') count.drop++
          if (o.status === 'Transférée') count.transfer++
          if (o.status === 'Reject') count.reject++
          if (o.status === 'Attente') count.waiting++
        })
        return count
      },

      isAdmin () {
        return this.$store.state.authorization.role === 'Admin'
      },
      storeDeliveries () {
        return this.$store.state.deliveries
      }
    },

    watch: {
      storeDeliveries: {
        handler () {
          this.processDeliveries()
        }
      },
      '$route.query.wallFileId' (newWallFileId, oldWallFileId) {
        if (newWallFileId === oldWallFileId) return
        this.wallFileCacheId = ''
        this.wallFileCache = null
        this.processDeliveries()
      },
      billingSame: function (val) {
        var order = this.order
        if (!val) {
          order.payerAddress = ''
          order.payerCity = ''
          order.payerContact = ''
          order.payerFax = ''
          order.payerName = ''
          order.payerPhone = ''
          order.payerEmail = ''
          order.payerPostcode = ''
          order.payerProvince = ''
          order.payerCountry = ''
          order.sageID = ''
        } else {
          order.payerAddress = order.receiverAddress
          order.payerCity = order.receiverCity
          order.payerContact = order.receiverContact
          order.payerFax = order.receiverFax
          order.payerName = order.receiverName
          order.payerPhone = order.receiverPhone
          order.payerEmail = order.receiverEmail
          order.payerPostcode = order.receiverPostcode
          order.payerProvince = order.receiverProvince
          order.payerCountry = order.receiverCountry
          order.sageID = this.backup.sageIDDelivery || ''
          this.datalist.billing = ''
          this.datalist.billingUid = ''
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .red, .red:focus, .red:hover {
    color: white;
    background-color: #ad0001d1 !important;
  }
 
  .orange, .orange:focus {
    background-color: #ffa5009e !important;
    color: #353535
  }

  .yellow, .yellow:hover {
    background-color: #ffff00a3 !important;
  }

  .dispatch-info-tab {
    display: flex;
    flex-flow: row;
  }
  .kne-modal {
    max-width: 100%;
  }

  .table thead th {
    border-bottom: 1px solid #eceeef;
    border-top: none;
  }

  input, button {
    cursor: pointer;
  }

  #addOrder, #customView {
    position: relative;
  }

  .printed {
    background-color: #79cc79 !important;
    border-color: #79cc79 !important;
  }

  .kne-tab:hover {
    color: #f7941e !important;
  }

  .kne-tab.active {
    color: #f7941e !important;
  }

  th {
    resize: horizontal;
  }

  .view {
    padding-left: 11rem;
  }

  .sidebar {
    width: 10.5rem;
  }

  .current {
    border-left: 3px solid #f7941e;
  }

  .mapModal {
    max-width: 80% !important;
  }

  /* Style for VueGoogleAutocomplete and Address book search */
  .input-special {
    width: 100%;
    border: 1px solid;
    border-radius: 2px;
  }

  /* Style for the the main contents of the page */
  .content-container {
    overflow-x: hidden;
    display:flex;
    width: 100%;
  }

  /* Style for the the main contents of the page (mobile)*/
  .content-container-mobile {
    flex-direction: column;
  }

    /* Style for the miscellaneous container of the page (not maps) */
    .misc-content-container {
      display: flex;
      width: 100%;
    }

    /* Style for the miscellaneous contents of the page (Not maps // mobile) */
    .misc-content-container-mobile {
      display:flex;
      flex-direction: column;
      width: 100%;
    }

      /* Style for the miscellaneous contents of the page */
      .misc-content {
        width: 100%;
      }

      .maps-container {
        display: flex;
        flex-direction: row !important;
        justify-content: space-between;
        width: 100%;
        flex-wrap: nowrap;
        gap: 20px;
      }

      .maps-subcontainer {
        flex: 1;
        min-width: 0;
        max-width: calc(50% - 10px);
        transition: all 0.3s ease;
      }

      .map-title {
        display: flex;
        flex-direction: row !important;
        align-items: center;
        justify-content: center;
      }
      /* Responsive adjustments for small screens */
      .mobile-maps-container {
        flex-direction: column;
        gap: 10px;
      }

      .mobile-maps-container {
        max-width: 100%;
      }

  /* Style for maps in mobile mode */
  .mobile-map {
    margin-bottom: 2rem;
    border: solid 1px;
    border-radius: 5px;
    width: 95% !important;
  }

  /* Style for car order day limit */
  .legend {
    display: flex;
    justify-content: space-between;
    font-style: italic;
    color: white;
    background-color: #2c2d2f;
  }

  /* Style for car order day limit */
  .legend span {
    margin: 0.5rem;
  }

  .modal-misc {
    display: flex;
    width: 30%;
    max-width: 30%;
  }

    .fa-ship, .fa-road, .fa-hand-holding-usd {
      padding: 0px;
      font-size: 1.2rem;
    }

    .modal-misc__btn--width {
      min-width: 100%;
      max-width: 100%;
    }

    .modal-misc__btn--focused {
      font-weight: bold;
      border: black solid 2px;
      border-radius: 2px !important;
    }

    .modal-misc__btn--focusedV2 {
      background-color: rgb(25, 155, 255);
      border: black solid 1px;
      border-radius: 2px !important;
    }

    .modal-misc__btn--true {
      background-color:rgb(1, 165, 1);
    }

    .modal-misc__btn--false {
      background-color:#ea4335;
    }

    .modal-misc__btn--null {
      background-color: #ffa500;
      border-bottom: none;
    }

    .modal-misc__waypt-list {
      background-color: #fad184;
      border-radius: 0px;
      opacity: 0.9;
    }

    .modal-misc__mapUrl--focused {
      background-color: rgb(216, 247, 250);
    }

  .modal-location {
    display: flex;
    width: 58%;
    max-width: 58%;
  }

  .modal-map {
    width: 26%;
  }

  .overflow {
    overflow-x: hidden;
    overflow-wrap: break-word;
  }

  .text--center {
    flex-direction: column;
    text-align: center;
  }

  .unfocused:hover {
    opacity: 0.8;
  }

  .unfocused {
    opacity: 0.6;
  }

  .unfocusedV2 {
    background-color: #f0f0f0;
  }

  .border-bottom {
    border-bottom: black solid 1px;
  }

  .border-radius-none {
    border-radius: 0px !important;
  }

  .display--flex {
    display: flex;
  }
  /* Animation for map toggling */
.map-toggle-enter-active, .map-toggle-leave-active {
  transition: opacity 0.3s, max-height 0.3s;
  overflow: hidden;
}

.map-toggle-enter-from, .map-toggle-leave-to {
  opacity: 0;
  max-height: 0;
}

.map-toggle-enter-to, .map-toggle-leave-from {
  opacity: 1;
  max-height: 500px;
}

@media (max-width: 768px) {
  .maps-container {
    display: flex;
    flex-direction: column !important;
  }

  .maps-subcontainer {
    width: 100%;
    max-width: 100% !important;
    margin-inline: 12px;
  }
}
</style>
